import React, { useState, useEffect, useReducer, useRef, useContext } from 'react';
import fileDownloader from 'js-file-download';
import { useLocation } from 'react-router-dom';
import {
    Toolbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    Paper,
    TablePagination,
    Grid,
    Typography,
    Button,
    Tooltip,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import { Skeleton } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CheckIcon from '@material-ui/icons/Check';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import WarningIcon from '@material-ui/icons/Warning'
import CloseIcon from '@material-ui/icons/Close';
import ReloadIcon from '@material-ui/icons/Loop';
import AddIcon from '@material-ui/icons/Add';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EventIcon from '@material-ui/icons/Event';
import FilterListIcon from '@material-ui/icons/FilterList';
import MapPopup from '../../components/Popup';
import FullScreenDialog from '../../components/FullScreenDialog';
import Alert from '../../components/Alert';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import DvrIcon from '@material-ui/icons/Dvr';
import FaceIcon from '@material-ui/icons/Face';
import VideocamOutlinedIcon from '@material-ui/icons/VideocamOutlined';
import Select from '../../components/Select';
import Canvas from '../../components/Canvas';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import CachedIcon from '@material-ui/icons/Cached';
import PeopleIcon from '@material-ui/icons/People';
import CardTravelIcon from '@mui/icons-material/CardTravel';
import ReportIcon from '@mui/icons-material/Report';
import { makeStyles } from '@material-ui/core/styles';
import { grey, green, red } from '@material-ui/core/colors';

import SideMenu from '../../components/SideMenu';
import Popup from '../../components/Popup';
import DateTimePicker from '../../components/DateTimePicker';
import InputSearch from '../../components/InputSearch';
import ExportModal from '../../components/ExportModal';
import Autocomplete from '../../components/Autocomplete';
import Input from '../../components/Input';
import { useTableColumnsToShow, ColumnsManagementModal } from './components/UserListColumns';

import api from '../../services/api';
import BluePin from '../../assets/img/pin-blue.svg';
import CyanPin from '../../assets/img/pin-cyan.svg';
import GreenPin from '../../assets/img/pin-green.svg';
import OrangePin from '../../assets/img/pin-orange.svg';
import RedPin from '../../assets/img/pin-red.svg';

import mask from '../../utils/mask';
import date from '../../utils/date';

import Loader from 'react-loader-spinner';

import config from '../../configs/config';
import ResendValidation from '../../components/ResendValidation';
import { useDebounce } from '../../hooks/useDebounce';
import { PermissionsContext } from '../../providers/Permissions';
import { yellow } from "@mui/material/colors";

const { host, port } = config;

const filterInitialValues = {
    sex: {
        active: false,
        value: null,
    },
    person_type: {
        active: false,
        value: {},
    },
    org: {
        active: false,
        value: {},
    },
    created_at: {
        active: false,
        value: {
            start: null,
            end: null,
        },
    },
    updated_at: {
        active: false,
        value: {
            start: null,
            end: null,
        },
    },
    face_image: {
        active: false,
        value: null,
    },
}

const reduceFilters = (state, action) => {
    switch (action.type) {
        case 'activate':
            return {
                ...state,
                [action.filter]: {
                    ...state[action.filter],
                    active: action.value,
                }
            };
        case 'change':
            let newValues = state;

            if (!action.datatype || action.datatype === 'normal') {
                newValues = {
                    ...state,
                    [action.filter]: {
                        ...state[action.filter],
                        value: action.value,
                    }
                };
            } else if (action.datatype === 'object') { // only for 1 layered objects
                newValues = {
                    ...state,
                    [action.filter]: {
                        ...state[action.filter],
                        value: {
                            ...state[action.filter].value,
                            [action.key]: action.value
                        },
                    }
                };
            }
            return newValues;
        case 'reset':
            return filterInitialValues;
        default:
            return state;
    }
};

const CustomFilterItem = ({
    label,
    index,
    onActivate,
    onChooseInput,
    onChooseValue,
    onRemove,
    inputs,
    values,
    allowedToRemove,
}) => {

    const classes = useStyles();
    const [valueSearch, setValueSearch] = useState(values?.value ?? "");

    const handleFilter = (index, value) => {
        onChooseInput(index, value);
    }

    const handleValue = (index, value) => {
        onChooseValue(index, value);
    }

    const handleSearchValue = ({ target: { value } }) => setValueSearch(value);

    const handleRemove = () => onRemove(index);

    useEffect(() => {
        const handler = setTimeout(() => {
            handleValue(index, valueSearch);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valueSearch]);

    return (
        <Grid item xs={12}>
            <Paper variant="outlined" className={classes.customFilterCard}>
                <div className={classes.customFilterHeader}>
                    <FormControlLabel
                        label={label}
                        className={classes.formControl}
                        control={
                            <Checkbox
                                checked={values?.active}
                                color='primary'
                                onChange={({ target: { checked } }) => onActivate(index, checked)}
                            />
                        }
                    />
                    <Tooltip title={allowedToRemove ? 'Remover campo' : 'Mantenha ao menos um campo'}>
                        <span>
                            <IconButton
                                aria-label="Remover campo personalizado"
                                className={classes.removeCustomFilterButton}
                                onClick={handleRemove}
                                disabled={!allowedToRemove}
                                size="small"
                            >
                                <DeleteOutlineIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                </div>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={!!values?.filter?.id ? 6 : 12}>
                        <div className={classes.filterFieldLabel}>Campo</div>
                        <Autocomplete
                            options={inputs}
                            getOptionLabel={({ name }) => name || ''}
                            onChange={(_, value) => handleFilter(index, value)}
                            getOptionSelected={(option, value) => (option.id === value.id)}
                            value={values?.filter}
                            disabled={!values?.active}
                            required={true}
                            fullWidth />
                    </Grid>
                    {
                        (!!values?.filter?.id) && (values.filter.type === "select" ? (
                            <Grid item xs={12} sm={6}>
                                <div className={classes.filterFieldLabel}>Valor</div>
                                <Autocomplete
                                    options={(values.filter?.options ?? []).map((option) => (
                                        { id: option, name: option }
                                    ))}
                                    getOptionLabel={({ name }) => name || ''}
                                    onChange={(_, value) => onChooseValue(index, value)}
                                    getOptionSelected={(option, value) => (option.id === value.id)}
                                    value={values?.value}
                                    required={true}
                                    disabled={!values?.active}
                                    fullWidth />
                            </Grid>
                        ) : (
                            <Grid item xs={12} sm={6}>
                                <div className={classes.filterFieldLabel}>Valor</div>
                                <Input
                                    textFieldProps={{
                                        onChange: handleSearchValue,
                                        value: valueSearch,
                                        disabled: !values?.active,
                                        fullWidth: true,
                                        required: true
                                    }}
                                />
                            </Grid>
                        ))
                    }
                </Grid>
            </Paper>
        </Grid>
    );
};

const StatusTip = ({ success, type, content }) => {

    function getTipIcon() {
        switch (type) {
            case 'check':
                return <CheckIcon style={{ color: getTipColor() }} />;
            case 'error':
                return <CloseIcon style={{ color: getTipColor() }} />;
            case 'image':
                return <AccountCircleIcon style={{ color: getTipColor() }} />;
            default:
                throw new Error("Invalid tip type");
        }
    }

    function getTipColor() {
        if (success) {
            return green[700];
        } else {
            return red[700];
        }
    }

    return (
        <Tooltip title={
            <Typography variant='subtitle1' style={{
                fontSize: '1rem',
            }}>
                {content}
            </Typography>
        } arrow>
            <IconButton style={{ padding: 0 }}>
                {getTipIcon()}
            </IconButton>
        </Tooltip>
    );
};

const Pin = ({ pinAccesses, maxAccesses, style, name }) => {


    const [pinImage, setPinImage] = useState(null);
    const [pinColor, setPinColor] = useState('');

    useEffect(() => {
        try {
            const pin = parseInt(pinAccesses);
            // const total = parseInt(maxAccesses);
            const total = maxAccesses;

            // let blue = Math.round(total * 0.2);
            // let cyan = Math.round(total * 0.4);
            // let green = Math.round(total * 0.6);
            // let yellow = Math.round(total * 0.8);
            // let red = total;

            let blue = 10 * total;
            let cyan = 20 * total;
            let green = 30 * total;
            let yellow = 40 * total;
            //let red = 50 * total;

            let color = null;
            let image = null

            // console.log({ pin, total })
            // console.log({ blue, cyan, green, yellow, red });


            if (pin > yellow) {
                color = 1;
            } else if (pin > green && pin <= yellow) {
                color = 0.75;
            } else if (pin > cyan && pin <= green) {
                color = 0.5;
            } else if (pin > blue && pin <= cyan) {
                color = 0.25;
            } else if (pin > 0 && pin <= blue) {
                color = 0;
            }

            switch (color) {
                case 0:
                    image = BluePin;
                    setPinColor('blue');
                    break;
                case 0.25:
                    image = CyanPin;
                    setPinColor('cyan');
                    break;
                case 0.5:
                    image = GreenPin;
                    setPinColor('green');
                    break;
                case 0.75:
                    image = OrangePin;
                    setPinColor('yellow');
                    break;
                case 1:
                    image = RedPin;
                    setPinColor('red');
                    break;
                default:
                    console.log('error')
            }
            // console.log({ image })

            setPinImage(image);
        } catch (err) {
            console.log(err)
        }
    }, [pinAccesses, maxAccesses]);

    return (
        <Tooltip
            title={
                <div>
                    <Typography variant='subtitle1' style={{ fontWeight: 700 }}>
                        Câmera: &nbsp;
                        <Typography variant='subtitle2' style={{ fontWeight: 400 }}>
                            {name}:
                        </Typography>
                    </Typography>
                    <Typography variant='subtitle1' style={{ fontWeight: 700 }}>
                        Total de Acessos:
                        <Typography variant='subtitle2' style={{ fontWeight: 400 }}>
                            {pinAccesses}
                        </Typography>
                    </Typography>
                </div>
            }
            arrow
        >
            <img src={pinImage} alt={`${pinColor} location pin`} style={style} />
        </Tooltip>
    )
}

const FilterItem = ({ label, filter, children, filters, dispatchFilters, md = 6 }) => {
    const classes = useStyles();

    return (
        <Grid item xs={12} md={md}>
            <Paper
                variant="outlined"
                className={`${classes.filterCard} ${filters[filter].active ? classes.filterCardActive : ''}`}
            >
                <div className={classes.filterCardHeader}>
                    <FormControlLabel
                        label={label}
                        className={classes.formControl}
                        control={
                            <Checkbox
                                checked={filters[filter].active}
                                color='primary'
                                onChange={({ target: { checked } }) => dispatchFilters({
                                    type: 'activate',
                                    filter: filter,
                                    value: checked
                                })}
                            />
                        }
                    />
                    <span className={classes.filterStatus}>
                        {filters[filter].active ? 'Ativo' : 'Inativo'}
                    </span>
                </div>
                <div className={classes.filterCardContent}>
                    {children}
                </div>
            </Paper>
        </Grid>
    );
};

function getTime(time) {
    let currentISO = date().toISOString();
    let currentDate = new Date(currentISO);

    switch (time) {
        case 'start':
            currentDate.setHours(0, 0, 0, 0);
            return currentDate.toISOString();
        case 'end':
            return currentISO;
        default:
            return null
    }
}

export default function UserList() {
    const classes = useStyles();

    const {
        PermissionWrapper,
        PermissionOneOfWrapper,
        hasPermission,
    } = useContext(PermissionsContext);

    const location = useLocation();
    const { paramStartTime, paramEndTime } = (location && location.state) || {};

    const [openBackdrop, setOpenBackdrop] = useState(false);

    const handleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    }

    const [users, setUsers] = useState([]);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [openMapPopup, setOpenMapPopup] = useState(false);
    const [mediaUrl, setMediaUrl] = useState('');
    const [loadingMedia, setLoadingMedia] = useState(false);
    const [accessLog, setAccessLog] = useState(null);
    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [activePeriod, setActivePeriod] = useState(null);
    const [logCameras, setLogCameras] = useState([]);
    // const [maxAccesses, setMaxAccesses] = useState(0);
    const [logTotal, setLogTotal] = useState(0);
    const [logPage, setLogPage] = useState(0);
    const [logLimit, setLogLimit] = useState(10);

    const [selectedUser, setSelectedUser] = useState({});

    const [openResendPopup, setOpenResendPopup] = useState(false);
    const [submittingResend, setSubmittingResend] = useState(false);

    const [openReportPopup, setOpenReportPopup] = useState(false);

    const [filters, dispatchFilters] = useReducer(reduceFilters, filterInitialValues);

    const [openFiltersPopup, setOpenFiltersPopup] = useState(false);

    const [openExport, setOpenExport] = useState(false);

    const handleOpenExport = () => setOpenExport(true);
    const handleCloseExport = () => setOpenExport(false);

    const [loadingCount, setLoadingCount] = useState(false);
    const [loadingUsers, setLoadingUsers] = useState(false);


    const resendRef = useRef(null)

    const [userCustomInputsFilters, setUserCustomInputsFilters] = useState([{
        active: false,
        filter: null,
        value: null,
    }]);

    const [openColumnsModal, setOpenColumnsModal] = useState(false);
    const toggleColumnsModal = () => setOpenColumnsModal(!openColumnsModal);
    const { tableColumns, dispatchTableColumns } = useTableColumnsToShow();

    useEffect(() => {
        if (paramStartTime && paramEndTime) {
            dispatchFilters({
                type: 'activate',
                filter: 'created_at',
                value: true,
            });
            dispatchFilters({
                type: 'change',
                filter: 'created_at',
                value: {
                    start: paramStartTime,
                    end: paramEndTime,
                }
            });
            setRefresh(!refresh)
        }
        //eslint-disable-next-line
    }, [paramStartTime, paramEndTime]);

    const timeSet = (time) => {
        let currentISO = date().toISOString();
        let currentDate = new Date(currentISO);
        let start = null;
        let end = currentISO;
        switch (time) {
            case '24h':
                currentDate.setHours(currentDate.getHours() - 24);
                start = currentDate.toISOString();
                break;
            case 'today':
                currentDate.setHours(0, 0, 0, 0);
                start = currentDate.toISOString();
                break;
            case '7d':
                currentDate.setDate(currentDate.getDate() - 7);
                start = currentDate.toISOString();
                break;
            default:
                end = null;
        }
        setStartTime(start);
        setEndTime(end);
        setActivePeriod(time);
    }

    const seeImage = async (accessLog, useLoading = true, clearOnError = true) => {
        setLoadingMedia(true);
        setAccessLog(accessLog);

        try {
            const result = await api.get(`/access_log/image/${accessLog.id}`);

            const { image } = result.data;

            const imagePath = `http://${host}:${port}/midias/imagem/acesso/${image}`

            setMediaUrl(imagePath);
        } catch (err) {
            console.log(err);
            if (clearOnError) clearMedia();

            setMessage({
                open: true,
                variant: 'error',
                text: 'Não foi possível baixar a imagem do acesso',
            });
        }

        setLoadingMedia(false);
    }

    const watchVideo = async accessLog => {
        setLoadingMedia(true);
        setAccessLog(accessLog);

        try {
            const result = await api.get(`/access_log/video/${accessLog.id}`);

            const { video } = result.data;

            const videoPath = `http://${host}:${port}/midias/video/acesso/${video}`;

            setMediaUrl(videoPath);
            setLoadingMedia(false);
        } catch (err) {
            clearMedia();

            setMessage({
                open: true,
                variant: 'error',
                text: 'Não foi possível baixar o vídeo',
            });
        }
    };

    const clearMedia = () => {
        setAccessLog(null);
        setMediaUrl('');
        setLoadingMedia(false);
    };


    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    const accessStatus = ({ type, allowed }) => {
        switch (type) {
            case 'entry':
                return `Entrada ${allowed ? 'permitida' : 'negada'}`;
            case 'exit':
                return `Saída ${allowed ? 'permitida' : 'negada'}`;
            default:
                return `Acesso interno ${allowed ? 'permitido' : 'negado'}`;
        }
    };

    const [mapValue, setMapValue] = useState({ id: 0, map_image: "", name: "Mapa" });

    const [savedMaps, setSavedMaps] = useState([]);
    useEffect(() => {
        const findMap = async () => {
            try {
                const result = await api.get('/map/list');

                const { maps } = result.data;
                // console.log("Maps", maps)

                setSavedMaps(maps);
            } catch (err) {
                console.log(err.message);
            }
        };

        findMap();
    }, []);

    const [refresh, setRefresh] = useState(false);

    function updateRequest({ search }) {

        const loadData = async () => {
            setLoadingUsers(true);
            setLoadingCount(true);

            try {
                const resultFind = await api.get('/user/list', {
                    params: {
                        query_option: 'find',
                        start_time: paramStartTime ? paramStartTime : null,
                        end_time: paramEndTime ? paramEndTime : null,
                        search,
                        limit,
                        page,
                        filters: {
                            ...filters,
                            person_type: {
                                ...filters.person_type,
                                value: filters?.person_type?.value?.id ?? null,
                            },
                            org: {
                                ...filters.org,
                                value: filters?.org?.value?.id ?? null,
                            },
                            search_by_custom_inputs: userCustomInputsFilters,
                        },
                    },
                });

                const { users } = resultFind.data;

                setUsers(users);
                setTotal(999);
                setLoadingUsers(false);

                const resultCount = await api.get('/user/list', {
                    params: {
                        query_option: 'count',
                        start_time: paramStartTime ? paramStartTime : null,
                        end_time: paramEndTime ? paramEndTime : null,
                        search,
                        limit,
                        page,
                        filters: {
                            ...filters,
                            person_type: {
                                ...filters.person_type,
                                value: filters?.person_type?.value?.id ?? null,
                            },
                            org: {
                                ...filters.org,
                                value: filters?.org?.value?.id ?? null,
                            },
                            search_by_custom_inputs: userCustomInputsFilters,
                        },
                    },
                });

                const { count } = resultCount.data;

                setTotal(count);
            } catch (err) {
                console.log(err);
                setMessage({
                    variant: 'error',
                    open: true,
                    text: err.error,
                })
            }
            setLoadingCount(false);
            setLoadingUsers(false);

        };

        loadData();

    }

    const changePage = (_, newPage) => {
        setPage(newPage);
    };

    const quantityPerPage = ({ target }) => {
        setLimit(parseInt(target.value, 10));
        setPage(0);
    };

    const changeLogPage = (_, newPage) => {
        setLogPage(newPage);
    };

    const logQuantityPerPage = ({ target }) => {
        setLogLimit(parseInt(target.value, 10));
        setLogPage(0);
    };

    const [personTypes, setPersonTypes] = useState([]);
    const [personTypeSeach, setPersonTypeSearch] = useState("");
    const deboncedPersonTypeSearch = useDebounce(personTypeSeach, 500);

    useEffect(() => {
        const findTypes = async () => {
            try {
                const result = await api.get('/person_type/list', {
                    params: {
                        show_exceptions: true,
                        limit: 30,
                        page: 0,
                        search: deboncedPersonTypeSearch,
                    }
                });

                const { personTypes } = result.data;

                setPersonTypes(personTypes);
            } catch (err) {
                console.log(err)
            }
        }

        findTypes();
    }, [deboncedPersonTypeSearch]);

    const [orgsSelect, setOrgsSelect] = useState([]);
    const [orgSearch, setOrgSearch] = useState("");
    const debouncedOrgsSearch = useDebounce(orgSearch, 500);

    useEffect(() => {
        const findOrg = async () => {
            try {
                const result = await api.get('/organizational_structure/index', {
                    params: {
                        limit: 10,
                        page: 0,
                        search: debouncedOrgsSearch,
                    }
                });

                const { orgs } = result.data;

                setOrgsSelect(orgs);
            } catch (err) {
                console.log(err.message);
            }
        };

        findOrg();
    }, [debouncedOrgsSearch]);

    const [customInputs, setCustomInputs] = useState([]);
    useEffect(() => {
        const findInputs = async () => {
            try {
                const result = await api.get('/custom_input/list', {
                    params: {
                        page: 0,
                        limit: 30,
                    }
                });

                const { custom_inputs } = result.data;

                setCustomInputs(custom_inputs);
            } catch (err) {
                console.log(err);
            }
        };

        findInputs();
    }, []);

    useEffect(() => {
        // console.log("opening popup")
        if (!openMapPopup) {
            // console.log('false value')
            setMapValue({ id: 0, map_image: "", name: "Mapa" })
            setStartTime(getTime('start'))
            setEndTime(getTime('end'))
            setCurrentUser(null)
            setLogCameras([]);
            setLogs([]);
            setLogTotal(0);
            setActivePeriod(null);
            setSelectedMapItem(null);
        }
    }, [openMapPopup]);

    const personTypeName = (id) => {
        let result = ''
        if (!id)
            return "|Não informado|"

        personTypes.forEach(current => {
            if (current.id === id) {
                result = current.name;
            }
        });

        return result;
    };

    const lastEventType = event => {
        switch (event) {
            case 'entry':
                return 'Entrada';
            case 'exit':
                return 'Saída';
            default:
                return 'Acesso interno';
        }
    };

    const [logs, setLogs] = useState([]);


    function setCurrentMap(e) {
        let currentMap = null;
        setLogCameras([]);
        setLogs([]);
        setLogTotal(0);
        setLogPage(0);
        setSelectedMapItem(null);
        savedMaps.forEach(map => {
            if (map.id === e.target.value) {
                currentMap = map;
            }
        })

        // console.log(currentMap)
        setMapValue(currentMap || { id: 0, map_image: "", name: "Mapa" })
    }

    const [currentUser, setCurrentUser] = useState(null);

    function openModal(id) {
        setOpenMapPopup(true);
        let newUser = null;
        users.forEach(user => {
            if (user.id === id) {
                newUser = user;
            }
        })
        // console.log(newUser)
        setCurrentUser(newUser)
    }

    const [max, setMax] = useState(0);

    const getDeviceStatusTip = (relation) => {

        if (relation?.uid && relation?.error_type === null) {
            return <StatusTip success={true} type='check' content='Cadastrado(a) com sucesso' />;
        } else if (relation?.uid && relation?.error_type === "invalid_face_image") {
            return <StatusTip success={false} type='image' content='Cadastrado(a) com imagem inválida' />;
        } else if (!relation?.uid) {
            return <StatusTip success={false} type='error' content='Não cadastrado(a)' />
        } else {
            return;
        }

    }

    useEffect(() => {
        const loadData = async () => {
            try {
                if (mapValue?.id !== 0 && currentUser?.id) {
                    const result = await api.get('/access_log/list_by_map', {
                        params: {
                            user: currentUser?.id,
                            map: mapValue?.id,
                            startTime: startTime,
                            endTime: endTime,
                            limit: logLimit,
                            page: logPage,
                        },
                    });

                    const { log, count, cameras } = result.data;

                    setLogs(log);
                    setLogTotal(count);
                    setLogCameras(cameras);
                    // setMaxAccesses(cameras[0]?.max);
                    // setMax(parseInt(maxNumber))
                    const diffs = date(endTime).diff(startTime, 'days') !== 0 ? date(endTime).diff(startTime, 'days') + 1 : 1;
                    setMax(diffs)
                    // console.log(maxAccesses)
                }
            } catch (err) {
                console.log(err);
            }
        };

        loadData();
        // eslint-disable-next-line
    }, [startTime, endTime, logLimit, logPage, mapValue])

    const [hover, setHover] = useState('40px');
    // const [opacity, setOpacity] = useState(100);
    const [indexLog, setIndexLog] = useState(null);
    const [selectedMapItem, setSelectedMapItem] = useState(null);

    function handleHover(index) {
        setHover('60px');
        // setOpacity(0);
        setIndexLog(index)
    }

    function handleLeaveHover() {
        setIndexLog(null)
        setHover('40px');
        // setOpacity(100);
    }

    function handleSelectMapItem(index) {
        setSelectedMapItem(current => current === index ? null : index);
    }

    const highlightedMapItem = indexLog !== null ? indexLog : selectedMapItem;
    const accessReaders = selectedUser?.devices?.filter(device => device.type === 'dhi') || [];
    const accessRecorders = selectedUser?.devices?.filter(device => device.type !== 'dhi') || [];
    const accessCameras = selectedUser?.cameras || [];

    function manageResending(user) {
        setSelectedUser(user);
        setOpenResendPopup(true);
    }

    async function resendUser() {

        try {
            setSubmittingResend(true);
            const data = resendRef.current.getValues();
            console.log(data)
            const result = await api.post(`/user/resend/${selectedUser.id}`, data);

            if (result.status === 204) {
                setMessage({
                    open: true,
                    variant: 'success',
                    text: "Pessoa reenviada com sucesso"
                });
            }

            setSelectedUser(null);
            setOpenResendPopup(false);
            setSubmittingResend(false);
            setRefresh(!refresh)
        } catch (err) {
            console.log(err);
            setMessage({
                open: true,
                variant: 'error',
                text: err.error
            });
            setSelectedUser(null);
            setOpenResendPopup(false);
            setSubmittingResend(false);
        }
    }

    function manageReport(user) {
        setSelectedUser(user);
        setOpenReportPopup(true);
    }

    const appendFilter = () => {
        setUserCustomInputsFilters([...userCustomInputsFilters, {
            active: false,
            filter: null,
            value: null,
        }])
    };

    const toggleUserCustomInputFilter = (index, checked) => {
        const newValues = Object.assign([], userCustomInputsFilters);

        newValues[index].active = checked;

        setUserCustomInputsFilters(newValues);
    }

    const changeUserCustomInputFilter = (index, value) => {
        const newValues = Object.assign([], userCustomInputsFilters);

        newValues[index].filter = value;

        setUserCustomInputsFilters(newValues);
    }

    const changeUserCustomInputFilterValue = (index, value) => {
        console.log("chainging value")
        const newValues = Object.assign([], userCustomInputsFilters);

        newValues[index].value = value;

        setUserCustomInputsFilters(newValues);
    }

    const handleRemoveFilter = (index) => {
        if (userCustomInputsFilters.length === 1) return;

        const newCustomInputs = Object.assign([], userCustomInputsFilters);

        newCustomInputs.splice(index, 1);

        setUserCustomInputsFilters(newCustomInputs);
    }

    const getSingleCustomInputs = () => {
        let alreadyFoundIDS = [];

        const activeCustomInputs = userCustomInputsFilters.filter(element => element?.filter?.id && element.active);

        if (!activeCustomInputs.length) return [];

        const uniqueCustomInputs = activeCustomInputs.filter(element => {
            if (alreadyFoundIDS.includes(element.filter.id))
                return false;

            alreadyFoundIDS.push(element.filter.id);
            return true;
        });

        return uniqueCustomInputs;
    }

    const resetFilters = () => {
        dispatchFilters({
            type: 'reset'
        });
        setUserCustomInputsFilters([{
            active: false,
            filter: null,
            value: null,
        }]);
    }

    const TableCellSkeleton = () => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Skeleton variant="rectangular" animation='wave' width='100%' height='2rem' />
            </div>
        )
    }

    const TableRowSkeleton = (key) => {
        return (
            <TableRow key={key}>
                <TableCell className={classes.tableBody}>
                    <TableCellSkeleton />
                </TableCell>
                <TableCell className={classes.tableBody}>
                    <TableCellSkeleton />
                </TableCell>
                {
                    (getSingleCustomInputs()).map((_, index) => (
                        <TableCell className={classes.tableBody} key={index}>
                            <TableCellSkeleton />
                        </TableCell>
                    ))
                }
                <TableCell className={classes.tableBody}>
                    <TableCellSkeleton />
                </TableCell>
                <TableCell className={classes.tableBody}>
                    <TableCellSkeleton />
                </TableCell>
                <TableCell className={classes.tableBody}>
                    <TableCellSkeleton />
                </TableCell>
                <TableCell className={classes.tableBody}>
                    <TableCellSkeleton />
                </TableCell>
                <TableCell className={classes.tableBody}>
                    <TableCellSkeleton />
                </TableCell>
                <TableCell className={classes.tableBody}>
                    <TableCellSkeleton />
                </TableCell>
                <TableCell className={classes.tableBody}>
                    <TableCellSkeleton />
                </TableCell>
                <TableCell className={classes.tableBody}>
                    <TableCellSkeleton />
                </TableCell>
                <TableCell className={classes.tableBody}>
                    <TableCellSkeleton />
                </TableCell>
                <TableCell className={classes.tableBody}>
                    <TableCellSkeleton />
                </TableCell>
                <TableCell className={classes.tableBody}>
                    <TableCellSkeleton />
                </TableCell>
            </TableRow>
        );
    };

    const TableBodySkeleton = () => {

        const loadRows = () => {
            const rows = [];
            for (let i = 0; i < (total < limit ? total : limit); i++) {
                rows.push('');
            }
            return rows;
        }

        const rowsNumber = loadRows();

        return (
            <TableBody>
                {
                    !!rowsNumber.length && rowsNumber.map((_, rowIndex) => (
                        <TableRowSkeleton key={rowIndex} />
                    ))
                }
            </TableBody>
        );
    }

    const handleExportUsers = async (fileType, exportDestination, destinationEmail) => {
        try {
            await api.get('/user/export', {
                params: {
                    start_time: paramStartTime ? paramStartTime : null,
                    end_time: paramEndTime ? paramEndTime : null,
                    search,
                    limit,
                    page,
                    filters: {
                        ...filters,
                        person_type: {
                            ...filters.person_type,
                            value: filters?.person_type?.value?.id ?? null,
                        },
                        org: {
                            ...filters.org,
                            value: filters?.org?.value?.id ?? null,
                        },
                        search_by_custom_inputs: userCustomInputsFilters,
                    },
                    exportationType: fileType,
                    exportDestination: exportDestination,
                    destinationEmail: destinationEmail
                },
                responseType: exportDestination === "website" ? 'blob' : undefined,
            }).then((res) => {
                const suggestedFileName = res.headers['x-suggested-filename'];
                if (exportDestination === "website")
                    fileDownloader(res.data, suggestedFileName);
                else setMessage({
                    open: true,
                    variant: 'success',
                    text: `Em breve o arquivo gerado deve chegar em seu email "${destinationEmail}"`,
                });
            });
        } catch (err) {
            console.log(err);
            setMessage({
                open: true,
                variant: "error",
                text: "Não foi possível realizar a exportação",
            });
        }
    }

    const handleExportUserAccessReport = async (userId, startTime, endTime) => {
        try {
            const res = await api.get('/exportUserReport', {
                params: {
                    user_id: userId,
                    startTime: startTime ?? null,
                    endTime: endTime ?? null,
                },
                responseType: 'blob',
            });

            const suggestedFileName = res.headers['x-suggested-filename'] || `relatorio_usuario_${userId}.pdf`;
            fileDownloader(res.data, suggestedFileName);

        } catch (err) {
            console.log(err);
            setMessage({
                open: true,
                variant: "error",
                text: "Erro ao gerar o relatório PDF",
            });
        }
    };


    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <div className={classes.heading}>
                            <div className={classes.headingIcon}>
                                <PeopleIcon />
                            </div>
                            <Typography variant="h5" className={classes.title}>
                                Lista de Pessoas
                            </Typography>
                        </div>
                    </Grid>
                    
                    <Grid item xs={12}>
                        <div className={classes.tableCard}>
                            <div className={classes.cardHeader}>
                                <div>
                                    <Typography className={classes.cardTitle}>
                                        Pessoas cadastradas
                                    </Typography>
                                    <Typography className={classes.resultCount}>
                                        {loadingCount
                                            ? 'Atualizando lista...'
                                            : `${total} ${total === 1
                                                ? 'registro encontrado'
                                                : 'registros encontrados'}`}
                                    </Typography>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <InputSearch
                                        textFieldProps={{
                                            placeholder: 'Buscar por nome...',
                                            fullWidth: true,
                                            'aria-label': 'Buscar tipo de pessoa',
                                        }}
                                        request={updateRequest}
                                        pagination={[refresh, page, limit]}
                                        className={classes.inputSearch}
                                    />
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        onClick={() => setOpenFiltersPopup(true)}
                                        className={classes.filterButton}
                                    >
                                        Filtros
                                    </Button>

                                    <PermissionWrapper route="/pessoa/exportar">

                                        <Button
                                            variant='contained'
                                            color='primary'
                                            onClick={handleOpenExport}
                                            className={classes.filterButton}
                                        >
                                            Exportar
                                        </Button>

                                    </PermissionWrapper>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        onClick={toggleColumnsModal}
                                        className={classes.filterButton}
                                    >
                                        Campos
                                    </Button>

                                    
                                </div>
                            </div>

                            <TableContainer component={Paper}>
                                <Table className={classes.table} size="small" aria-label="access history">
                                    <TableHead>
                                        <TableRow>
                                            {(tableColumns.showID) && (
                                                <TableCell className={classes.tableHead}>ID</TableCell>
                                            )}
                                            {(tableColumns.showName) && (
                                                <TableCell className={classes.tableHead}>Nome</TableCell>
                                            )}
                                            {(tableColumns.showWarning) && (
                                                <TableCell className={classes.tableHead}>Aviso</TableCell>
                                            )}
                                            {
                                                (getSingleCustomInputs()).map((customInput, index) => (
                                                    <TableCell className={classes.tableHead}
                                                        key={index}>{customInput.filter.name}</TableCell>
                                                ))
                                            }
                                            {(tableColumns.showActive) && (
                                                <TableCell className={classes.tableHead}>Ativo</TableCell>
                                            )}
                                            {(tableColumns.showFace) && (
                                                <TableCell className={classes.tableHead}>Face</TableCell>
                                            )}
                                            {(tableColumns.showOnDevices) && (
                                                <TableCell className={classes.tableHead}>Dispositivos</TableCell>
                                            )}
                                            {(tableColumns.showSex) && (
                                                <TableCell className={classes.tableHead}>Sexo</TableCell>
                                            )}
                                            {(tableColumns.showDocType) && (
                                                <TableCell className={classes.tableHead}>Tipo de Documento</TableCell>
                                            )}
                                            {(tableColumns.showDocNumber) && (
                                                <TableCell className={classes.tableHead}>Nº do Documento</TableCell>
                                            )}
                                            {(tableColumns.showPhone) && (
                                                <TableCell className={classes.tableHead}>Telefone</TableCell>
                                            )}
                                            {(tableColumns.showEmail) && (
                                                <TableCell className={classes.tableHead}>E-mail</TableCell>
                                            )}
                                            {(tableColumns.showPersonType) && (
                                                <TableCell className={classes.tableHead}>Tipo</TableCell>
                                            )}
                                            {(tableColumns.showOrganization) && (
                                                <TableCell className={classes.tableHead}>Organização</TableCell>
                                            )}
                                            {(tableColumns.showLastEvent) && (
                                                <TableCell className={classes.tableHead}>Último evento</TableCell>
                                            )}
                                            <PermissionOneOfWrapper
                                                routes={[
                                                    "/visitante/modificar/:id",
                                                    "/procurado/modificar/:id",
                                                    "/pessoa/modificar/:id",
                                                    "/pessoa/mapa_de_calor",
                                                    "/pessoa/equipamentos_com_acesso",
                                                    "/pessoa/reenviar",
                                                ]}
                                            >
                                                <TableCell className={classes.tableHead}>Ações</TableCell>
                                            </PermissionOneOfWrapper>
                                        </TableRow>
                                    </TableHead>
                                    {
                                        !!loadingUsers ? (
                                            <TableBodySkeleton />
                                        ) : (
                                            <TableBody>
                                                {!!users && users.map(user => (
                                                    <TableRow key={user.id} className={classes.tableRow} >
                                                        {(tableColumns.showID) && (
                                                            <TableCell className={classes.tableBody} component="th"
                                                                scope="row">
                                                                {user.id}
                                                            </TableCell>
                                                        )}
                                                        {(tableColumns.showName) && (
                                                            <TableCell className={classes.tableBody}>
                                                                {user.name.toUpperCase()}
                                                            </TableCell>
                                                        )}
                                                        {(tableColumns.showWarning) && (
                                                            <TableCell className={classes.tableBody}>
                                                                {user.notes && user.notes.trim() !== '' ? (
                                                                    <Tooltip title={user.notes} classes={{ tooltip: classes.tooltip }}>
                                                                        <Chip
                                                                            label={
                                                                                <GppMaybeIcon

                                                                                    className={classes.warningIcon}
                                                                                />
                                                                            }
                                                                            size="medium"
                                                                            className={classes.warningAccess}
                                                                        />
                                                                    </Tooltip>
                                                                ) : (
                                                                    <Chip
                                                                        textAlign="center"
                                                                        label={<VerifiedUserIcon
                                                                            className={classes.authorizationIconOk}
                                                                        />}
                                                                        size="medium"
                                                                        className={classes.authorizedAccess}
                                                                    />
                                                                )}
                                                            </TableCell>
                                                        )}
                                                        {
                                                            (getSingleCustomInputs()).map((customInput, index) => (
                                                                <TableCell className={classes.tableBody} key={index}>
                                                                    {
                                                                        (user.user_custom_inputs ?? []).find(userCI => userCI.custom_input_id === customInput.filter.id)?.information ?? "-"
                                                                    }
                                                                </TableCell>
                                                            ))
                                                        }
                                                        {(tableColumns.showActive) && (
                                                            <TableCell className={classes.tableBody}>
                                                                {user.active_register ? (
                                                                    <Chip
                                                                        label={<CheckIcon
                                                                            className={classes.authorizationIconOk} />}
                                                                        size="medium"
                                                                        className={classes.authorizedAccess}
                                                                    />
                                                                ) : (
                                                                    <Chip
                                                                        label={<CloseIcon
                                                                            className={classes.authorizationIconOff} />}
                                                                        size="medium"
                                                                        className={classes.unauthorizedAccess}
                                                                    />
                                                                )}
                                                            </TableCell>
                                                        )}
                                                        {(tableColumns.showFace) && (
                                                            <TableCell className={classes.tableBody}>
                                                                {user.face_image ? (
                                                                    <Chip
                                                                        label={<HowToRegIcon
                                                                            className={classes.authorizationIconOk} />}
                                                                        size="medium"
                                                                        className={classes.authorizedAccess}
                                                                    />
                                                                ) : (
                                                                    <Chip
                                                                        label={<PersonOffIcon
                                                                            className={classes.authorizationIconOff} />}
                                                                        size="medium"
                                                                        className={classes.unauthorizedAccess}
                                                                    />
                                                                )}
                                                            </TableCell>
                                                        )}
                                                        {(tableColumns.showOnDevices) && (
                                                            <TableCell className={classes.tableBody}>
                                                                {user.devices?.length ? (
                                                                    user.devices.every(device => {
                                                                        if (device.relation[0]?.uid) return true;
                                                                        else return false;
                                                                    }) ? (
                                                                        <Chip
                                                                            label={<CheckIcon
                                                                                className={classes.authorizationIconOk} />}
                                                                            size="medium"
                                                                            className={classes.authorizedAccess}
                                                                        />
                                                                    ) : (
                                                                        <Chip
                                                                            label={<CloseIcon
                                                                                className={classes.authorizationIconOff} />}
                                                                            size="medium"
                                                                            className={classes.unauthorizedAccess}
                                                                        />
                                                                    )
                                                                ) : '-'}
                                                            </TableCell>
                                                        )}
                                                        {(tableColumns.showSex) && (
                                                            <TableCell className={classes.tableBody}>
                                                                {
                                                                    (user.sex === 'male') ? 'Masculino'
                                                                        : (user.sex === 'female') ? 'Feminino'
                                                                            : (user.sex === 'unknown') ? 'Outro'
                                                                                : 'Desconhecido'
                                                                }
                                                            </TableCell>
                                                        )}
                                                        {(tableColumns.showDocType) && (
                                                            <TableCell className={classes.tableBody}>
                                                                {user.doc_type && user?.doc_type === 'ic' ? 'RG' :
                                                                    user?.doc_type === 'passport' ? 'Passaporte' :
                                                                        user?.doc_type === 'other' ? 'Outro' :
                                                                            user?.doc_type === 'unknown' ? 'CPF' :
                                                                                '-'}
                                                            </TableCell>
                                                        )}
                                                        {(tableColumns.showDocNumber) && (
                                                            <TableCell className={classes.tableBody}>
                                                                {user.doc_number ? user.doc_number : "-"}
                                                            </TableCell>
                                                        )}
                                                        {(tableColumns.showPhone) && (
                                                            <TableCell className={classes.tableBody}>
                                                                {user.phone !== null ? ((user.phone.length === 10) ? (
                                                                    mask('(##) ####-####', user.phone)
                                                                ) : (
                                                                    mask('(##) #####-####', user.phone)
                                                                )) : '-'}
                                                            </TableCell>
                                                        )}
                                                        {(tableColumns.showEmail) && (
                                                            <TableCell className={classes.tableBody}>
                                                                {user.email !== null ? (user.email) : '-'}
                                                            </TableCell>
                                                        )}
                                                        {(tableColumns.showPersonType) && (
                                                            <TableCell className={classes.tableBody}>
                                                                {personTypeName(user.person_type_id)}
                                                            </TableCell>
                                                        )}
                                                        {(tableColumns.showOrganization) && (
                                                            <TableCell className={classes.tableBody}>
                                                                {
                                                                    !!user.OrganizationalStructure
                                                                        ? user.OrganizationalStructure.name
                                                                        : '-'
                                                                }
                                                            </TableCell>
                                                        )}
                                                        {(tableColumns.showLastEvent) && (
                                                            <TableCell className={classes.tableBody}>
                                                                {(user.access_logs.length > 0) && (
                                                                    lastEventType(user.access_logs[0].action_type)
                                                                )}
                                                            </TableCell>
                                                        )}
                                                        <PermissionOneOfWrapper
                                                            routes={[
                                                                "/visitante/modificar/:id",
                                                                "/procurado/modificar/:id",
                                                                "/pessoa/modificar/:id",
                                                                "/pessoa/mapa_de_calor",
                                                                "/pessoa/equipamentos_com_acesso",
                                                                "/pessoa/reenviar",
                                                            ]}
                                                        >
                                                            <TableCell className={classes.tableBody}>
                                                                <Grid justify='center' container spacing={1}>
                                                                    {
                                                                        user.person_type_id && user.person_type_id === 4 ? (
                                                                            <PermissionWrapper
                                                                                route="/visitante/modificar/:id">
                                                                                <Tooltip title="Editar Usuário" placement="top" arrow>
                                                                                    <Grid item>
                                                                                        <Button
                                                                                            type="button"
                                                                                            variant="contained"
                                                                                            size="small"
                                                                                            color="primary"
                                                                                            className={classes.actionButton}
                                                                                            href={`/visitante/modificar/${user.id}`}
                                                                                            fullWidth={true}
                                                                                        >
                                                                                            <EditIcon style={{ fontSize: 20 }} />
                                                                                        </Button>
                                                                                    </Grid>
                                                                                </Tooltip>
                                                                            </PermissionWrapper>
                                                                        ) : user.person_type_id && user.person_type_id === 2 ? (
                                                                            <PermissionWrapper
                                                                                route="/procurado/modificar/:id">
                                                                                <Tooltip title="Editar Usuário" placement="top" arrow>
                                                                                    <Grid item>
                                                                                        <Button
                                                                                            type="button"
                                                                                            variant="contained"
                                                                                            size="small"
                                                                                            color="primary"
                                                                                            className={classes.actionButton}
                                                                                            href={`/procurado/modificar/${user.id}`}
                                                                                            fullWidth={true}
                                                                                        >
                                                                                            <EditIcon style={{ fontSize: 20 }} />
                                                                                        </Button>
                                                                                    </Grid>
                                                                                </Tooltip>
                                                                            </PermissionWrapper>
                                                                        ) : (
                                                                            <PermissionWrapper
                                                                                route="/pessoa/modificar/:id">
                                                                                <Tooltip title="Editar Usuário" placement="top" arrow>
                                                                                    <Grid item>
                                                                                        <Button
                                                                                            type="button"
                                                                                            variant="contained"
                                                                                            size="small"
                                                                                            color="primary"
                                                                                            className={classes.actionButton}
                                                                                            href={`/pessoa/modificar/${user.id}`}
                                                                                            fullWidth={true}
                                                                                        >
                                                                                            <EditIcon style={{ fontSize: 20 }} />
                                                                                        </Button>
                                                                                    </Grid>
                                                                                </Tooltip>
                                                                            </PermissionWrapper>
                                                                        )
                                                                    }
                                                                    <PermissionWrapper route="/pessoa/mapa_de_calor">
                                                                        <Tooltip title="Ver Histórico" placement="top" arrow>
                                                                            <Grid item>
                                                                                <Button
                                                                                    type="button"
                                                                                    variant="contained"
                                                                                    size="small"
                                                                                    color="primary"
                                                                                    style={{ background: '#ECB365' }}
                                                                                    className={classes.actionButton}
                                                                                    onClick={() => openModal(user.id)}
                                                                                    fullWidth={true}
                                                                                >
                                                                                    <VisibilityIcon style={{ fontSize: 20 }} />
                                                                                </Button>
                                                                            </Grid>
                                                                        </Tooltip>
                                                                    </PermissionWrapper>
                                                                    <PermissionWrapper
                                                                        route="/pessoa/equipamentos_com_acesso">
                                                                        <Tooltip title="Dispositivos Cadastrados" placement="top" arrow>
                                                                            <Grid item>
                                                                                <Button
                                                                                    type="button"
                                                                                    variant="contained"
                                                                                    size="small"
                                                                                    color="primary"
                                                                                    style={{ background: '#5b8262' }}
                                                                                    className={classes.actionButton}
                                                                                    onClick={() => manageReport(user)}
                                                                                    fullWidth={true}
                                                                                >
                                                                                    <AssignmentIcon style={{ fontSize: 20 }} />
                                                                                </Button>
                                                                            </Grid>
                                                                        </Tooltip>
                                                                    </PermissionWrapper>
                                                                    <PermissionWrapper route="/pessoa/reenviar">
                                                                        {
                                                                            user.face_image && (
                                                                                <Tooltip title="Reenviar Face" placement="top" arrow>
                                                                                    <Grid item>
                                                                                        <Button
                                                                                            type="button"
                                                                                            variant="contained"
                                                                                            size="small"
                                                                                            color="primary"
                                                                                            style={{ background: grey[400] }}
                                                                                            className={classes.actionButton}
                                                                                            onClick={() => manageResending(user)}
                                                                                            fullWidth={true}
                                                                                        >
                                                                                            <ReloadIcon style={{ fontSize: 20 }} />
                                                                                        </Button>
                                                                                    </Grid>
                                                                                </Tooltip>
                                                                            )
                                                                        }
                                                                    </PermissionWrapper>
                                                                </Grid>
                                                            </TableCell>
                                                        </PermissionOneOfWrapper>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        )
                                    }
                                </Table>
                            </TableContainer>
                        </div>
                        <TablePagination
                            rowsPerPageOptions={[10, 20, 30]}
                            component="div"
                            count={total}
                            rowsPerPage={limit}
                            page={page}
                            labelDisplayedRows={({ from, to, count }) =>
                                loadingCount
                                    ? `${from}-${to} de carregando...`
                                    : `${from}-${to} de ${count !== -1 ? count : '—'}`
                            }
                            labelRowsPerPage="Registros por página"
                            onChangePage={changePage}
                            onChangeRowsPerPage={quantityPerPage}
                        />
                    </Grid>
                </Grid>
                <PermissionOneOfWrapper
                    routes={[
                        "/procurado/criar",
                        "/visitante/criar",
                        "/pessoa/criar",
                    ]}
                >
                    <Box className={classes.fabButton}>
                        <Backdrop open={openBackdrop} />
                        <SpeedDial
                            ariaLabel="SpeedDial tooltip example"
                            sx={{
                                position: 'absolute',
                                bottom: 16,
                                right: 16,
                                '& button:first-of-type': {
                                    backgroundColor: '#3f51b5',

                                }
                            }}
                            icon={<SpeedDialIcon />}
                            onClose={handleBackdrop}
                            onOpen={handleBackdrop}
                            open={openBackdrop}
                        >
                            {/* for some reason the SpeedDial doesnt accept anything wrapping the SpeedDialAction, even Fragments, so either return it plain or dont :/ */}
                            {
                                [
                                    {
                                        route: "/procurado/criar",
                                        component: (
                                            <SpeedDialAction
                                                icon={<ReportIcon />}
                                                tooltipTitle={'Procurado'}
                                                tooltipOpen
                                                FabProps={{
                                                    href: '/procurado/criar'
                                                }}
                                            />
                                        ),
                                    },
                                    {
                                        route: "/visitante/criar",
                                        component: (
                                            <SpeedDialAction
                                                icon={<CardTravelIcon />}
                                                tooltipTitle={'Visitante'}
                                                tooltipOpen
                                                FabProps={{
                                                    href: '/visitante/criar'
                                                }}
                                            />
                                        ),
                                    },
                                    {
                                        route: "/pessoa/criar",
                                        component: (
                                            <SpeedDialAction
                                                icon={<PeopleIcon />}
                                                tooltipTitle={'Regular'}
                                                tooltipOpen
                                                FabProps={{
                                                    href: '/pessoa/criar'
                                                }}
                                            />
                                        ),
                                    },
                                ].filter((element) => hasPermission(element.route)).map((element) => element.component)
                            }
                        </SpeedDial>
                    </Box>
                </PermissionOneOfWrapper>
            </main>
            <MapPopup
                openPopup={openMapPopup}
                setOpenPopup={setOpenMapPopup}
                height='90%'
                width='90%'
                maxWidth='xl'
                title={`Histórico de ${currentUser?.name.toUpperCase()} `}
            >
                <div className={classes.mapPopupIntro}>
                    <div>
                        <Typography className={classes.mapPopupIntroTitle}>
                            Visão geral dos acessos
                        </Typography>
                        <Typography variant="body2" className={classes.mapPopupIntroText}>
                            Filtre o período e selecione um mapa para relacionar os registros às câmeras.
                        </Typography>
                    </div>
                    <Button
                        variant="outlined"
                        color="primary"
                        className={classes.exportButton}
                        startIcon={<PictureAsPdfIcon />}
                        onClick={() => handleExportUserAccessReport(currentUser?.id, startTime, endTime)}
                    >
                        Gerar PDF
                    </Button>
                </div>

                <Paper elevation={0} className={classes.mapFiltersCard}>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12} sm={6} lg={3}>
                            <DateTimePicker
                                label='Data de Início'
                                className={classes.dateTimeInput}
                                format="DD/MM/YYYY HH:mm"
                                value={startTime}
                                placeholder="Início"
                                onChange={(selectedDate) => {
                                    setStartTime(selectedDate && selectedDate.format());
                                    setActivePeriod(null);
                                }}
                                cancelLabel="cancelar"
                                disabled={false}
                                fullWidth={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <DateTimePicker
                                label='Data de Fim'
                                className={classes.dateTimeInput}
                                format="DD/MM/YYYY HH:mm"
                                value={endTime}
                                placeholder="Fim"
                                onChange={(selectedDate) => {
                                    setEndTime(selectedDate && selectedDate.format());
                                    setActivePeriod(null);
                                }}
                                cancelLabel="cancelar"
                                disabled={false}
                                fullWidth={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <Select
                                label="Mapa de localização"
                                options={savedMaps.map(map => ({ label: map.name, value: map.id }))}
                                textFieldProps={{
                                    id: 'c_loc',
                                    onChange: setCurrentMap,
                                    value: mapValue.id,
                                    fullWidth: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <Typography variant="caption" className={classes.quickFiltersLabel}>
                                Períodos rápidos
                            </Typography>
                            <div className={classes.quickFilters}>
                                {[
                                    { value: 'today', label: 'Hoje' },
                                    { value: '24h', label: '24 horas' },
                                    { value: '7d', label: '7 dias' },
                                ].map(period => (
                                    <Button
                                        key={period.value}
                                        variant={activePeriod === period.value ? 'contained' : 'outlined'}
                                        color="primary"
                                        size="md"
                                        className={classes.quickFilterButton}
                                        onClick={() => timeSet(period.value)}
                                    >
                                        {period.label}
                                    </Button>
                                ))}
                            </div>
                        </Grid>
                    </Grid>
                </Paper>

                <Grid container spacing={3} alignItems="stretch" className={classes.mapPopupPanels}>
                    <Grid item xs={12} lg={6}>
                        <Paper elevation={0} className={classes.mapPanel}>
                            <div className={classes.mapPanelHeader}>
                                <div>
                                    <Typography variant="h6" className={classes.mapPanelTitle}>
                                        Histórico de acessos
                                    </Typography>
                                    <Typography variant="body2" className={classes.mapPanelSubtitle}>
                                        Passe o cursor ou selecione uma linha para localizar a câmera no mapa.
                                    </Typography>
                                </div>
                                <Chip
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    label={`${logTotal} ${logTotal === 1 ? 'registro' : 'registros'}`}
                                />
                            </div>

                            <TableContainer className={classes.mapTableContainer}>
                                <Table className={classes.table} size="small" aria-label="Histórico de acessos" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHead}>Câmera</TableCell>
                                            <TableCell className={classes.tableHead}>Localização</TableCell>
                                            <TableCell className={classes.tableHead}>Horário</TableCell>
                                            <TableCell className={classes.tableHead}>Acesso</TableCell>
                                            <TableCell className={classes.tableHead}>Mídia</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {mapValue.id === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={5} className={classes.emptyTableCell}>
                                                    <div className={classes.emptyState}>
                                                        <span className={classes.emptyStateIcon}>◎</span>
                                                        <Typography className={classes.emptyStateTitle}>
                                                            Selecione um mapa
                                                        </Typography>
                                                        <Typography variant="body2" className={classes.emptyStateText}>
                                                            Os acessos do período aparecerão aqui.
                                                        </Typography>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        {mapValue.id !== 0 && logs.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={5} className={classes.emptyTableCell}>
                                                    <div className={classes.emptyState}>
                                                        <span className={classes.emptyStateIcon}>○</span>
                                                        <Typography className={classes.emptyStateTitle}>
                                                            Nenhum acesso encontrado
                                                        </Typography>
                                                        <Typography variant="body2" className={classes.emptyStateText}>
                                                            Tente selecionar outro período.
                                                        </Typography>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        {mapValue.id !== 0 && logs.map((log, index) => {
                                            if (log.camera && log.camera.map_id === mapValue.id) {
                                                return (
                                                    <TableRow
                                                        key={index}
                                                        hover
                                                        tabIndex={0}
                                                        aria-selected={selectedMapItem === log.camera_id}
                                                        onMouseEnter={() => handleHover(log.camera_id)}
                                                        onMouseLeave={handleLeaveHover}
                                                        onClick={() => handleSelectMapItem(log.camera_id)}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                handleSelectMapItem(log.camera_id);
                                                            }
                                                        }}
                                                        className={`${classes.tableRow} ${selectedMapItem === log.camera_id ? classes.selectedTableRow : ''}`}
                                                    >
                                                        <TableCell className={classes.tableBody} component="th" scope="row">
                                                            {log.camera.name}
                                                        </TableCell>
                                                        <TableCell className={classes.tableBody}>
                                                            {log.camera?.place_cameras?.name || '-'}
                                                        </TableCell>
                                                        <TableCell className={classes.tableBody}>
                                                            {date(log.event_time).toLocaleFormat()}
                                                        </TableCell>
                                                        <TableCell className={classes.tableBody}>
                                                            <Chip
                                                                icon={log.allowed_access
                                                                    ? <CheckIcon className={classes.authorizationIcon} />
                                                                    : <CloseIcon className={classes.authorizationIcon} />}
                                                                label={accessStatus({
                                                                    type: log.action_type,
                                                                    allowed: log.allowed_access,
                                                                })}
                                                                size="small"
                                                                className={log.allowed_access
                                                                    ? classes.authorizedAccess
                                                                    : classes.unauthorizedAccess}
                                                            />
                                                        </TableCell>
                                                        <TableCell className={classes.tableBody}>
                                                            {(accessLog && accessLog.id === log.id && loadingMedia) ? (
                                                                <Button
                                                                    variant="contained"
                                                                    disabled
                                                                    size="small"
                                                                    className={classes.actionButton}
                                                                >
                                                                    <CachedIcon fontSize="small" className={classes.loadingMediaIcon} />
                                                                </Button>
                                                            ) : (
                                                                <Tooltip title="Reproduzir vídeo" arrow>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        size="small"
                                                                        className={classes.actionButton}
                                                                        onClick={(event) => {
                                                                            event.stopPropagation();
                                                                            watchVideo(log);
                                                                        }}
                                                                        aria-label="Reproduzir vídeo do acesso"
                                                                    >
                                                                        <PlayArrowIcon fontSize="small" />
                                                                    </Button>
                                                                </Tooltip>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            }

                                            if (log.Device) {
                                                return (
                                                    <TableRow
                                                        key={index}
                                                        hover
                                                        tabIndex={0}
                                                        aria-selected={selectedMapItem === log.device_id}
                                                        onMouseEnter={() => handleHover(log.device_id)}
                                                        onMouseLeave={handleLeaveHover}
                                                        onClick={() => handleSelectMapItem(log.device_id)}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                handleSelectMapItem(log.device_id);
                                                            }
                                                        }}
                                                        className={`${classes.tableRow} ${selectedMapItem === log.device_id ? classes.selectedTableRow : ''}`}
                                                    >
                                                        <TableCell className={classes.tableBody} component="th" scope="row">
                                                            {log.Device.name}
                                                        </TableCell>
                                                        <TableCell className={classes.tableBody}>
                                                            {log.Device?.place_devices?.name || '-'}
                                                        </TableCell>
                                                        <TableCell className={classes.tableBody}>
                                                            {date(log.event_time).toLocaleFormat()}
                                                        </TableCell>
                                                        <TableCell className={classes.tableBody}>
                                                            <Chip
                                                                icon={log.allowed_access
                                                                    ? <CheckIcon className={classes.authorizationIcon} />
                                                                    : <CloseIcon className={classes.authorizationIcon} />}
                                                                label={accessStatus({
                                                                    type: log.action_type,
                                                                    allowed: log.allowed_access,
                                                                })}
                                                                size="small"
                                                                className={log.allowed_access
                                                                    ? classes.authorizedAccess
                                                                    : classes.unauthorizedAccess}
                                                            />
                                                        </TableCell>
                                                        <TableCell className={classes.tableBody}>
                                                            {log.person_face_image !== null ? (
                                                                (accessLog && accessLog.id === log.id && loadingMedia) ? (
                                                                    <Button
                                                                        variant="contained"
                                                                        disabled
                                                                        size="small"
                                                                        className={classes.actionButton}
                                                                    >
                                                                        <CachedIcon fontSize="small" className={classes.loadingMediaIcon} />
                                                                    </Button>
                                                                ) : (
                                                                    <Tooltip title="Visualizar imagem" arrow>
                                                                        <Button
                                                                            variant="contained"
                                                                            color="primary"
                                                                            size="small"
                                                                            className={classes.actionButton}
                                                                            onClick={(event) => {
                                                                                event.stopPropagation();
                                                                                seeImage(log);
                                                                            }}
                                                                            aria-label="Visualizar imagem do acesso"
                                                                        >
                                                                            <VisibilityIcon fontSize="small" />
                                                                        </Button>
                                                                    </Tooltip>
                                                                )
                                                            ) : '-'}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            }

                                            return null;
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                className={classes.mapPagination}
                                rowsPerPageOptions={[10, 20, 30]}
                                component="div"
                                count={logTotal}
                                rowsPerPage={logLimit}
                                page={logPage}
                                labelDisplayedRows={({ from, to, count }) =>
                                    loadingCount
                                        ? `${from}-${to} de carregando...`
                                        : `${from}-${to} de ${count !== -1 ? count : '—'}`
                                }
                                labelRowsPerPage="Registros por página"
                                onChangePage={changeLogPage}
                                onChangeRowsPerPage={logQuantityPerPage}
                            />
                        </Paper>
                    </Grid>

                    <Grid item xs={12} lg={6}>
                        <Paper elevation={0} className={classes.mapPanel}>
                            <div className={classes.mapPanelHeader}>
                                <div>
                                    <Typography variant="h6" className={classes.mapPanelTitle}>
                                        Mapa de acessos
                                    </Typography>
                                    <Typography variant="body2" className={classes.mapPanelSubtitle}>
                                        {mapValue.id !== 0 ? mapValue.name : 'Nenhum mapa selecionado'}
                                    </Typography>
                                </div>
                            </div>

                            <div className={classes.mapViewport}>
                                {mapValue.id === 0 ? (
                                    <div className={classes.emptyState}>
                                        <span className={classes.emptyStateIcon}>⌖</span>
                                        <Typography className={classes.emptyStateTitle}>
                                            Selecione um mapa para começar
                                        </Typography>
                                        <Typography variant="body2" className={classes.emptyStateText}>
                                            As câmeras e a intensidade dos acessos serão exibidas aqui.
                                        </Typography>
                                    </div>
                                ) : (
                                    <>
                                        <div className={classes.mapCanvasStage}>
                                            <Canvas image={`${mapValue.map_image}`} getCursorPos={() => null} />
                                            {logCameras.map((element, index) => {
                                                if (mapValue.id !== element.camera.map_id) return null;

                                                const isHighlighted = element.camera_id === highlightedMapItem;

                                                return (
                                                    <div
                                                        key={index}
                                                        role="button"
                                                        tabIndex={0}
                                                        aria-label={`Selecionar câmera ${element.camera.name}`}
                                                        className={classes.mapPinButton}
                                                        onClick={() => handleSelectMapItem(element.camera_id)}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                handleSelectMapItem(element.camera_id);
                                                            }
                                                        }}
                                                        style={{
                                                            top: `${element.camera.y_axis}px`,
                                                            left: `${element.camera.x_axis}px`,
                                                        }}
                                                    >
                                                        <Pin
                                                            pinAccesses={element?.count}
                                                            maxAccesses={max}
                                                            name={element?.camera.name}
                                                            style={{
                                                                width: `${isHighlighted ? hover : 40}px`,
                                                                transition: 'width .2s ease, opacity .2s ease',
                                                                opacity: highlightedMapItem === null || isHighlighted ? 1 : 0.22,
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>

                                        {logCameras.length === 0 && (
                                            <div className={classes.mapNoDataBanner}>
                                                Nenhum acesso encontrado neste mapa e período.
                                            </div>
                                        )}

                                        {logCameras.length > 0 && (
                                            <div className={classes.mapLegend}>
                                                <Typography className={classes.mapLegendTitle}>
                                                    Intensidade de acessos
                                                </Typography>
                                                <div className={classes.mapLegendItems}>
                                                    {[
                                                        { label: `1–${10 * max}`, image: BluePin, color: 'azul' },
                                                        { label: `${(10 * max) + 1}–${20 * max}`, image: CyanPin, color: 'ciano' },
                                                        { label: `${(20 * max) + 1}–${30 * max}`, image: GreenPin, color: 'verde' },
                                                        { label: `${(30 * max) + 1}–${40 * max}`, image: OrangePin, color: 'laranja' },
                                                        { label: `+${(40 * max) + 1}`, image: RedPin, color: 'vermelho' },
                                                    ].map(item => (
                                                        <div className={classes.mapLegendItem} key={item.color}>
                                                            <img src={item.image} alt={`Pin ${item.color}`} />
                                                            <span>{item.label}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </Paper>
                    </Grid>
                </Grid>

                <FullScreenDialog
                    open={!!(mediaUrl && !loadingMedia)}
                    title={accessLog && (
                        `${(accessLog.camera) ? accessLog.camera.name : accessLog.Device.name}
                        (${(accessLog.camera) ? accessLog.camera.device.name : ''})`
                    )}
                    onClose={clearMedia}
                >
                    {(accessLog && accessLog.camera_id) ?
                        <video controls className={classes.video}>
                            <source src={mediaUrl} />
                        </video>
                        :
                        <img src={mediaUrl} className={classes.video} alt="IMAGEM" />
                    }
                </FullScreenDialog>
            </MapPopup>
            <Popup
                openPopup={openResendPopup}
                setOpenPopup={setOpenResendPopup}
                width='85%'
                // height='45%'
                title={`Deseja reenviar ${selectedUser?.name} a seus respectivos dispositivos novamente?`}
            >
                <Grid container spacing={2} justify='center'>
                    <ResendValidation user={selectedUser} ref={resendRef} />
                    {
                        !!selectedUser?.devices?.filter(device => device.type === 'dhi').length && (
                            <Grid item xs={12}>
                                <Typography variant='h5'>
                                    Dispositivos
                                </Typography>
                                <Grid container spacing={1}>
                                    {
                                        selectedUser?.devices?.filter(device => device.type === 'dhi')?.map(device => (
                                            <Grid item xs={4} key={`${device.id}`}>
                                                <Typography variant='subtitle1'>
                                                    - {device.name}
                                                </Typography>
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            </Grid>
                        )
                    }
                    {
                        !!selectedUser?.cameras?.length && (
                            <Grid item xs={12}>
                                <Typography variant='h5'>
                                    Câmeras
                                </Typography>
                                <Grid container spacing={1}>
                                    {
                                        selectedUser?.cameras?.map(camera => (
                                            <Grid item xs={6} key={`${camera.id}`}>
                                                <Typography variant='subtitle1'>
                                                    - {camera.name} | ({camera.device?.name})
                                                </Typography>
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            </Grid>
                        )
                    }
                    <Grid item xs={12} md={4}>
                        <Button
                            type="button"
                            variant="contained"
                            size="small"
                            color="primary"
                            className={classes.actionButton}
                            onClick={() => resendUser()}
                            fullWidth={true}
                            disabled={submittingResend}
                        >
                            {submittingResend ? 'ENVIANDO...' : 'SIM'}
                        </Button>
                    </Grid>
                </Grid>
            </Popup>
            <Popup
                openPopup={openReportPopup}
                setOpenPopup={setOpenReportPopup}
                title={`Dispositivos e câmeras de acesso — ${selectedUser?.name}`}
                width='min(92vw, 1100px)'
                maxWidth='lg'
            >
                <div className={classes.accessPopupSummary}>
                    <div className={classes.accessPopupSummaryIcon}>
                        <FaceIcon />
                    </div>
                    <div className={classes.accessPopupSummaryText}>
                        <Typography className={classes.accessPopupSummaryTitle}>
                            Visão geral dos vínculos
                        </Typography>
                        <Typography variant="body2" className={classes.accessPopupSummarySubtitle}>
                            Consulte onde essa pessoa está cadastrada e quais dispositivos estão associados.
                        </Typography>
                    </div>
                    <div className={classes.accessPopupCounters}>
                        <Chip
                            size="small"
                            label={`${accessReaders.length} ${accessReaders.length === 1 ? 'leitor' : 'leitores'}`}
                            className={classes.accessPopupCounter}
                        />
                        <Chip
                            size="small"
                            label={`${accessRecorders.length} ${accessRecorders.length === 1 ? 'NVR' : 'NVRs'}`}
                            className={classes.accessPopupCounter}
                        />
                        <Chip
                            size="small"
                            label={`${accessCameras.length} ${accessCameras.length === 1 ? 'câmera' : 'câmeras'}`}
                            className={classes.accessPopupCounter}
                        />
                    </div>
                </div>

                {accessReaders.length === 0 && accessRecorders.length === 0 ? (
                    <Paper elevation={0} className={classes.accessPopupEmptyState}>
                        <div className={classes.accessPopupEmptyIcon}>
                            <DvrIcon />
                        </div>
                        <Typography className={classes.accessPopupEmptyTitle}>
                            Nenhum dispositivo vinculado
                        </Typography>
                        <Typography variant="body2" className={classes.accessPopupEmptyText}>
                            Essa pessoa ainda não possui acesso associado a leitores, NVRs ou câmeras.
                        </Typography>
                    </Paper>
                ) : (
                    <Grid container spacing={2} alignItems="stretch" className={classes.accessPopupSections}>
                        {accessReaders.length > 0 && (
                            <Grid item xs={12} md={accessRecorders.length > 0 ? 5 : 12}>
                                <Paper elevation={0} className={classes.accessDeviceSection}>
                                    <div className={classes.accessSectionHeader}>
                                        <div className={classes.accessSectionHeading}>
                                            <span className={classes.accessSectionIcon}>
                                                <FaceIcon />
                                            </span>
                                            <div>
                                                <Typography className={classes.accessSectionTitle}>
                                                    Leitores faciais
                                                </Typography>
                                                <Typography variant="body2" className={classes.accessSectionSubtitle}>
                                                    Dispositivos de controle de acesso
                                                </Typography>
                                            </div>
                                        </div>
                                        <Chip size="small" label={accessReaders.length} className={classes.accessCountChip} />
                                    </div>

                                    <Grid container spacing={1} className={classes.accessReaderGrid}>
                                        {accessReaders.map(device => (
                                            <Grid item xs={12} sm={6} md={accessRecorders.length > 0 ? 12 : 4} key={device.id}>
                                                <div className={classes.accessDeviceCard}>
                                                    <span className={classes.accessDeviceCardIcon}>
                                                        <FaceIcon />
                                                    </span>
                                                    <Typography className={classes.accessDeviceName} noWrap title={device.name}>
                                                        {device.name}
                                                    </Typography>
                                                    <span className={classes.accessDeviceStatus}>
                                                        {getDeviceStatusTip(device?.relation[0])}
                                                    </span>
                                                </div>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Paper>
                            </Grid>
                        )}

                        {accessRecorders.length > 0 && (
                            <Grid item xs={12} md={accessReaders.length > 0 ? 7 : 12}>
                                <Paper elevation={0} className={classes.accessDeviceSection}>
                                    <div className={classes.accessSectionHeader}>
                                        <div className={classes.accessSectionHeading}>
                                            <span className={classes.accessSectionIcon}>
                                                <DvrIcon />
                                            </span>
                                            <div>
                                                <Typography className={classes.accessSectionTitle}>
                                                    NVRs e câmeras
                                                </Typography>
                                                <Typography variant="body2" className={classes.accessSectionSubtitle}>
                                                    Expanda um NVR para visualizar suas câmeras
                                                </Typography>
                                            </div>
                                        </div>
                                        <Chip size="small" label={accessRecorders.length} className={classes.accessCountChip} />
                                    </div>

                                    <div className={classes.accessAccordionList}>
                                        {accessRecorders.map(device => {
                                            const deviceCameras = accessCameras.filter(camera => camera.device_id === device.id);

                                            return (
                                                <Accordion key={device.id} elevation={0} className={classes.accessAccordion}>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls={`${device.name}-content`}
                                                        id={`${device.name}-header`}
                                                        className={classes.accessAccordionSummary}
                                                    >
                                                        <div className={classes.accessAccordionHeading}>
                                                            <span className={classes.accessDeviceCardIcon}>
                                                                <DvrIcon />
                                                            </span>
                                                            <Typography className={classes.accessDeviceName} noWrap title={device.name}>
                                                                {device.name}
                                                            </Typography>
                                                            <Chip
                                                                size="small"
                                                                variant="outlined"
                                                                label={`${deviceCameras.length} ${deviceCameras.length === 1 ? 'câmera' : 'câmeras'}`}
                                                                className={classes.accessCameraCount}
                                                            />
                                                            <span className={classes.accessDeviceStatus}>
                                                                {getDeviceStatusTip(device?.relation[0])}
                                                            </span>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.accessAccordionDetails}>
                                                        {deviceCameras.length > 0 ? (
                                                            <Grid container spacing={1}>
                                                                {deviceCameras.map(camera => (
                                                                    <Grid key={camera.id} item xs={12} sm={6}>
                                                                        <div className={classes.accessCameraCard}>
                                                                            <VideocamOutlinedIcon />
                                                                            <Typography noWrap title={camera.name}>
                                                                                {camera.name}
                                                                            </Typography>
                                                                        </div>
                                                                    </Grid>
                                                                ))}
                                                            </Grid>
                                                        ) : (
                                                            <Typography variant="body2" className={classes.accessNoCameras}>
                                                                Nenhuma câmera vinculada a este NVR.
                                                            </Typography>
                                                        )}
                                                    </AccordionDetails>
                                                </Accordion>
                                            );
                                        })}
                                    </div>
                                </Paper>
                            </Grid>
                        )}
                    </Grid>
                )}

                <Paper elevation={0} className={classes.accessStatusLegend}>
                    <Typography className={classes.accessStatusLegendTitle}>
                        Referência dos status
                    </Typography>
                    <div className={classes.accessStatusLegendItems}>
                        <div className={classes.accessStatusLegendItem}>
                            <StatusTip success={true} type='check' content='Cadastrado(a) com sucesso' />
                            <span>Cadastrado com sucesso</span>
                        </div>
                        <div className={classes.accessStatusLegendItem}>
                            <StatusTip success={false} type='image' content='Cadastrado(a) com imagem inválida' />
                            <span>Imagem inválida</span>
                        </div>
                        <div className={classes.accessStatusLegendItem}>
                            <StatusTip success={false} type='error' content='Não cadastrado(a)' />
                            <span>Não cadastrado</span>
                        </div>
                    </div>
                </Paper>
            </Popup>
            <Popup
                title='Filtrar pessoas'
                openPopup={openFiltersPopup}
                setOpenPopup={setOpenFiltersPopup}
                width='92%'
                maxWidth='md'
            >
                <div className={classes.filtersModal}>
                    <div className={classes.filtersIntro}>
                        <div className={classes.filtersIntroIcon}>
                            <FilterListIcon />
                        </div>
                        <div>
                            <Typography className={classes.filtersIntroTitle}>
                                Refine os resultados da lista
                            </Typography>
                            <Typography className={classes.filtersIntroText}>
                                Ative os filtros que deseja usar na busca.
                            </Typography>
                        </div>
                    </div>

                    <Paper elevation={0} className={classes.filterSection}>
                        <div className={classes.filterSectionHeader}>
                            <div className={classes.filterSectionIcon}>
                                <PeopleIcon />
                            </div>
                            <div>
                                <Typography className={classes.filterSectionTitle}>
                                    Dados da pessoa
                                </Typography>
                                <Typography className={classes.filterSectionDescription}>
                                    Características pessoais, vínculo e status do cadastro facial.
                                </Typography>
                            </div>
                        </div>
                        <Grid container spacing={2}>
                            <FilterItem label="Sexo" filter='sex' filters={filters} dispatchFilters={dispatchFilters}>
                                <Select
                                    options={[
                                        { label: 'Selecione um valor', value: null },
                                        { label: 'Masculino', value: 'male' },
                                        { label: 'Feminino', value: 'female' },
                                        { label: 'Desconhecido', value: 'unknown' }
                                    ]}
                                    textFieldProps={{
                                        onChange: ({ target: { value } }) => dispatchFilters({
                                            type: 'change',
                                            filter: 'sex',
                                            value,
                                        }),
                                        value: filters.sex.value,
                                        disabled: !filters.sex.active,
                                        fullWidth: true
                                    }}
                                />
                            </FilterItem>
                            <FilterItem label="Tipo de pessoa" filter='person_type' filters={filters}
                                dispatchFilters={dispatchFilters}>
                                <Autocomplete
                                    id="type_of_person"
                                    options={personTypes}
                                    getOptionLabel={({ name }) => name || ''}
                                    onChange={(_, value) => dispatchFilters({
                                        type: 'change',
                                        filter: 'person_type',
                                        value,
                                    })}
                                    getOptionSelected={(option, value) => (option.id === value.id)}
                                    onInputChange={(_, value) => setPersonTypeSearch(value)}
                                    value={filters.person_type?.value}
                                    disabled={!filters.person_type.active}
                                    fullWidth />
                            </FilterItem>
                            <FilterItem label="Organização" filter='org' filters={filters} dispatchFilters={dispatchFilters}>
                                <Autocomplete
                                    id="org"
                                    options={orgsSelect}
                                    getOptionLabel={({ name }) => name || ''}
                                    onChange={(_, value) => dispatchFilters({
                                        type: 'change',
                                        filter: 'org',
                                        value,
                                    })}
                                    getOptionSelected={(option, value) => (option.id === value.id)}
                                    onInputChange={(_, value) => setOrgSearch(value)}
                                    value={filters.org.value}
                                    required={false}
                                    disabled={!filters.org.active}
                                    fullWidth
                                />
                            </FilterItem>
                            <FilterItem label="Imagem facial" filter='face_image' filters={filters}
                                dispatchFilters={dispatchFilters}>
                                <Select
                                    options={
                                        [
                                            { label: 'Selecione um valor', value: null },
                                            { label: 'Cadastrada', value: true },
                                            { label: 'Não cadastrada', value: false },
                                        ]
                                    }
                                    textFieldProps={{
                                        onChange: ({ target: { value } }) => dispatchFilters({
                                            type: 'change',
                                            filter: 'face_image',
                                            value,
                                        }),
                                        value: filters.face_image.value,
                                        disabled: !filters.face_image.active,
                                        fullWidth: true
                                    }}
                                />
                            </FilterItem>
                        </Grid>
                    </Paper>

                    <Paper elevation={0} className={classes.filterSection}>
                        <div className={classes.filterSectionHeader}>
                            <div className={classes.filterSectionIcon}>
                                <EventIcon />
                            </div>
                            <div>
                                <Typography className={classes.filterSectionTitle}>
                                    Períodos
                                </Typography>
                                <Typography className={classes.filterSectionDescription}>
                                    Delimite as datas de criação ou da última alteração.
                                </Typography>
                            </div>
                        </div>
                        <Grid container spacing={2}>
                            <FilterItem label="Intervalo de criação" filter='created_at' filters={filters}
                                dispatchFilters={dispatchFilters} md={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <div className={classes.filterFieldLabel}>Início</div>
                                        <DateTimePicker
                                            format="DD/MM/YYYY HH:mm"
                                            value={filters.created_at.value.start}
                                            placeholder="Início"
                                            onChange={value => dispatchFilters({
                                                type: 'change',
                                                datatype: 'object',
                                                filter: 'created_at',
                                                key: 'start',
                                                value: (value && value.format())
                                            })}
                                            cancelLabel="cancelar"
                                            disabled={!filters.created_at.active}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <div className={classes.filterFieldLabel}>Fim</div>
                                        <DateTimePicker
                                            format="DD/MM/YYYY HH:mm"
                                            value={filters.created_at.value.end}
                                            placeholder="Fim"
                                            onChange={value => dispatchFilters({
                                                type: 'change',
                                                datatype: 'object',
                                                filter: 'created_at',
                                                key: 'end',
                                                value: (value && value.format())
                                            })}
                                            cancelLabel="cancelar"
                                            disabled={!filters.created_at.active}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                </Grid>
                            </FilterItem>
                            <FilterItem label="Intervalo de alteração" filter='updated_at' filters={filters}
                                dispatchFilters={dispatchFilters} md={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <div className={classes.filterFieldLabel}>Início</div>
                                        <DateTimePicker
                                            format="DD/MM/YYYY HH:mm"
                                            value={filters.updated_at.value.start}
                                            placeholder="Início"
                                            onChange={value => dispatchFilters({
                                                type: 'change',
                                                datatype: 'object',
                                                filter: 'updated_at',
                                                key: 'start',
                                                value: (value && value.format())
                                            })}
                                            cancelLabel="cancelar"
                                            disabled={!filters.updated_at.active}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <div className={classes.filterFieldLabel}>Fim</div>
                                        <DateTimePicker
                                            format="DD/MM/YYYY HH:mm"
                                            value={filters.updated_at.value.end}
                                            placeholder="Fim"
                                            onChange={value => dispatchFilters({
                                                type: 'change',
                                                datatype: 'object',
                                                filter: 'updated_at',
                                                key: 'end',
                                                value: (value && value.format())
                                            })}
                                            cancelLabel="cancelar"
                                            disabled={!filters.updated_at.active}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                </Grid>
                            </FilterItem>
                        </Grid>
                    </Paper>

                    <Paper elevation={0} className={classes.filterSection}>
                        <div className={classes.customFiltersSectionHeader}>
                            <div className={classes.filterSectionHeader}>
                                <div className={classes.filterSectionIcon}>
                                    <CardTravelIcon />
                                </div>
                                <div>
                                    <Typography className={classes.filterSectionTitle}>
                                        Campos personalizados
                                    </Typography>
                                    <Typography className={classes.filterSectionDescription}>
                                        Filtre usando campos específicos de cada pessoa.
                                    </Typography>
                                </div>
                            </div>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={appendFilter}
                                startIcon={<AddIcon />}
                                className={classes.addCustomFilterButton}
                            >
                                Adicionar campo
                            </Button>
                        </div>
                        <Grid container spacing={2}>
                            {
                                (userCustomInputsFilters ?? []).map((filter, index) => (
                                    <CustomFilterItem
                                        key={index}
                                        label="Usar este campo"
                                        index={index}
                                        onActivate={toggleUserCustomInputFilter}
                                        onChooseInput={changeUserCustomInputFilter}
                                        onChooseValue={changeUserCustomInputFilterValue}
                                        onRemove={handleRemoveFilter}
                                        inputs={customInputs}
                                        values={userCustomInputsFilters[index]}
                                        allowedToRemove={userCustomInputsFilters.length > 1}
                                    />
                                ))
                            }
                        </Grid>
                    </Paper>

                    <div className={classes.filtersFooter}>
                        <Button
                            variant='outlined'
                            fullWidth={true}
                            onClick={resetFilters}
                            className={classes.clearFiltersButton}
                        >
                            Limpar filtros
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            fullWidth={true}
                            onClick={() => setRefresh(!refresh)}
                            disabled={loadingCount}
                            className={classes.applyFiltersButton}
                        >
                            {
                                loadingCount ? (
                                    <div className={classes.filterLoader}>
                                        <Loader type="ThreeDots" color="#ffffff" height='auto' width='2rem' />
                                    </div>
                                ) : 'Aplicar filtros'
                            }
                        </Button>
                    </div>
                </div>
            </Popup>
            <ExportModal
                open={openExport}
                onClose={handleCloseExport}
                handleExport={handleExportUsers}
                title="Exportar pessoas"
            />
            <ColumnsManagementModal
                open={openColumnsModal}
                setOpen={setOpenColumnsModal}
                tableColumns={tableColumns}
                dispatchTableColumns={dispatchTableColumns}
            />
            {
                !!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )
            }
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(5),
    },
    heading: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    headingIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 48,
        height: 48,
        flexShrink: 0,
        borderRadius: 14,
        color: '#1d4ed8',
        background: 'linear-gradient(135deg, #dbeafe 0%, #eef2ff 100%)',
        '& svg': {
            fontSize: 27,
        },
    },
    title: {
        color: 'rgba(6, 19, 31, 1)',
        fontSize: 28,
        fontWeight: 600,
    },
    cardTitle: {
        color: '#1f2937',
        fontSize: 16,
        fontWeight: 700,
    },
    resultCount: {
        color: '#9ca3af',
        fontSize: 12,
        marginTop: 2,
    },
    inputSearch: {
        width: 340,
        maxWidth: '100%',
        '& .MuiTextField-root': {
            width: '100%',
        },
        '& .MuiOutlinedInput-root': {
            minHeight: 40,
            borderRadius:20,
            backgroundColor: '#f9fafb',
            transition: 'background-color 160ms ease, box-shadow 160ms ease',
            '&:hover': {
                backgroundColor: '#fff',
            },
            '&.Mui-focused': {
                backgroundColor: '#fff',
                boxShadow: '0 0 0 3px rgba(37, 99, 235, 0.10)',
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#dfe3e8',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    filterButton: {
        borderRadius: 9,
        boxShadow: '0 6px 14px rgba(25, 118, 210, .2)',
        fontWeight: 700,
        textTransform: 'none',
    },
    filtersModal: {
        color: '#1f2937',
        paddingTop: theme.spacing(.5),
    },
    filtersIntro: {
        alignItems: 'center',
        background: 'linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%)',
        border: '1px solid #dbeafe',
        borderRadius: 14,
        display: 'flex',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            alignItems: 'flex-start',
            padding: theme.spacing(1.5),
        },
    },
    filtersIntroIcon: {
        alignItems: 'center',
        backgroundColor: '#1976d2',
        borderRadius: 11,
        color: '#fff',
        display: 'flex',
        flexShrink: 0,
        height: 42,
        justifyContent: 'center',
        width: 42,
        '& svg': {
            fontSize: 22,
        },
    },
    filtersIntroTitle: {
        color: '#172033',
        fontSize: '1rem',
        fontWeight: 700,
    },
    filtersIntroText: {
        color: '#64748b',
        fontSize: '.85rem',
        lineHeight: 1.5,
        marginTop: 2,
    },
    filterSection: {
        backgroundColor: '#fbfdff',
        border: '1px solid #e2e8f0',
        borderRadius: 14,
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            borderLeft: 0,
            borderRadius: 0,
            borderRight: 0,
            marginLeft: theme.spacing(-2),
            marginRight: theme.spacing(-2),
            padding: theme.spacing(2),
        },
    },
    filterSectionHeader: {
        alignItems: 'center',
        display: 'flex',
        gap: theme.spacing(1.25),
        marginBottom: theme.spacing(2),
        minWidth: 0,
    },
    filterSectionIcon: {
        alignItems: 'center',
        backgroundColor: '#e3f2fd',
        borderRadius: 10,
        color: '#1976d2',
        display: 'flex',
        flexShrink: 0,
        height: 38,
        justifyContent: 'center',
        width: 38,
        '& svg': {
            fontSize: 20,
        },
    },
    filterSectionTitle: {
        color: '#1e293b',
        fontSize: '.95rem',
        fontWeight: 700,
    },
    filterSectionDescription: {
        color: '#64748b',
        fontSize: '.78rem',
        lineHeight: 1.4,
        marginTop: 1,
    },
    filterCard: {
        backgroundColor: '#fff',
        borderColor: '#e2e8f0',
        borderRadius: 11,
        height: '100%',
        padding: theme.spacing(1.5),
        transition: 'border-color .2s ease, box-shadow .2s ease',
        '& .MuiFormControlLabel-root': {
            marginLeft: -7,
        },
        '& .MuiFormControlLabel-label': {
            color: '#475569',
            fontSize: '.88rem',
            fontWeight: 700,
        },
    },
    filterCardActive: {
        borderColor: '#90caf9',
        boxShadow: '0 5px 16px rgba(25, 118, 210, .08)',
    },
    filterCardHeader: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1),
        minHeight: 32,
    },
    filterCardContent: {
        minWidth: 0,
    },
    filterStatus: {
        backgroundColor: '#f1f5f9',
        borderRadius: 999,
        color: '#94a3b8',
        flexShrink: 0,
        fontSize: '.67rem',
        fontWeight: 700,
        letterSpacing: '.03em',
        padding: '3px 8px',
        textTransform: 'uppercase',
        '$filterCardActive &': {
            backgroundColor: '#e3f2fd',
            color: '#1565c0',
        },
    },
    filterFieldLabel: {
        color: '#64748b',
        fontSize: '.72rem',
        fontWeight: 700,
        letterSpacing: '.02em',
        marginBottom: theme.spacing(.6),
    },
    customFiltersSectionHeader: {
        alignItems: 'center',
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2),
        '& $filterSectionHeader': {
            marginBottom: 0,
        },
        [theme.breakpoints.down('sm')]: {
            alignItems: 'stretch',
            flexDirection: 'column',
        },
    },
    customFilterCard: {
        backgroundColor: '#fff',
        borderColor: '#e2e8f0',
        borderRadius: 11,
        padding: theme.spacing(1.5),
        '& .MuiFormControlLabel-root': {
            marginLeft: -7,
        },
        '& .MuiFormControlLabel-label': {
            color: '#475569',
            fontSize: '.88rem',
            fontWeight: 700,
        },
    },
    customFilterHeader: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1),
    },
    addCustomFilterButton: {
        borderRadius: 9,
        flexShrink: 0,
        fontWeight: 600,
        textTransform: 'none',
        [theme.breakpoints.down('sm')]: {
            alignSelf: 'flex-start',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    removeCustomFilterButton: {
        color: '#64748b',
        '&:hover': {
            backgroundColor: '#fef2f2',
            color: '#b91c1c',
        },
    },
    filtersFooter: {
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, .97)',
        borderTop: '1px solid #e5e7eb',
        bottom: -20,
        boxShadow: '0 -8px 20px rgba(15, 23, 42, .04)',
        display: 'flex',
        gap: theme.spacing(1.5),
        justifyContent: 'flex-end',
        margin: theme.spacing(0, -3, -2.5),
        padding: theme.spacing(2, 3),
        position: 'sticky',
        zIndex: 5,
        '& > button': {
            flex: '0 1 180px',
            minHeight: 42,
        },
        [theme.breakpoints.down('xs')]: {
            bottom: -20,
            flexDirection: 'column-reverse',
            margin: theme.spacing(0, -2, -2.5),
            padding: theme.spacing(1.5, 2),
            '& > button': {
                flex: '0 0 auto',
                width: '100%',
            },
        },
    },
    clearFiltersButton: {
        borderColor: '#cbd5e1',
        borderRadius: 9,
        color: '#475569',
        fontWeight: 600,
        textTransform: 'none',
    },
    applyFiltersButton: {
        borderRadius: 9,
        boxShadow: '0 6px 14px rgba(25, 118, 210, .2)',
        fontWeight: 700,
        textTransform: 'none',
    },
    filterLoader: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        minHeight: 20,
    },
    authorizedAccess: {
        backgroundColor: '#e8f7ef',
        color: '#FFF',
        alignContent: 'center',
        textAlign: 'center',
        justifyContent: 'center',
        '& .MuiChip-label': {
            display: 'flex',
            alignItems: 'center',
            color: '#16794b',

        },
    },
    warningAccess: {
        backgroundColor: '#fff2da',
        color: '#FFF',
        '& .MuiChip-label': {
            display: 'flex',
            alignItems: 'center',

        }
    },
    unauthorizedAccess: {
        backgroundColor: '#fef2f2',
        color: '#FFF',
        '& .MuiChip-label': {
            display: 'flex',
            alignItems: 'center',

        }
    },
    tooltip: {
        fontSize: '1.2rem',
    },
    authorizationIcon: {
        color: '#FFF',
    },
    authorizationIconOff: {
        color: '#b91c1c',
    },
    authorizationIconOk: {
        color: '#16794b',
    },
    warningIcon: {
        color: '#ffa600',
    },
    videoButton: {
        lineHeight: 1,
        '& span > svg': {
            marginRight: 2,
        },
    },
    video: {
        maxHeight: '100%',
        height: '100%',
        maxWidth: '100%',
        display: 'block',
        margin: 'auto',
    },
    table: {
        minWidth: 500,
        width: '100%',
    },
    tableHead: {
        borderBottom: '1px solid #e5e7eb',
        fontWeight: 700,
        textAlign: 'center',
        padding: '14px 10px',
        textTransform: 'uppercase',
        backgroundColor: '#f8fafc',
        color: '#64748b',
        letterSpacing: '0.06em',
        fontSize: 11,
        position: 'sticky',
        top: 0,
    },
    tableBody: {
        color: '#374151',
        padding: '14px 10px',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 600,
        borderBottom: '1px solid #eef1f5',
    },
    tableRow: {
        transition: 'background-color 140ms ease',
        '&:hover': {
            backgroundColor: '#f8fbff',
            cursor: 'default'
        },
        '&:last-child td, &:last-child th': {
            borderBottom: 0,
        },
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(3),
        padding: theme.spacing(2.5, 3),
        borderBottom: '1px solid #e5e7eb',
        [theme.breakpoints.down('sm')]: {
            alignItems: 'stretch',
            flexDirection: 'column',
            gap: theme.spacing(2),
            padding: theme.spacing(2),
        },
    },
    tableCard: {
        overflow: 'hidden',
        border: '1px solid #e5e7eb',
        borderRadius: 16,
        backgroundColor: '#fff',
        boxShadow: '0 10px 30px rgba(15, 23, 42, 0.05)',
    },
    tableRow: {
        transition: 'background-color 0.2s ease, transform 0.2s ease',
        '&:hover': {
            backgroundColor: '#f3f6fb',
        },
        borderBottom: '1px solid #e5e7eb',
    },
    selectedTableRow: {
        backgroundColor: '#eaf3ff !important',
        boxShadow: 'inset 4px 0 0 #1976d2',
        '&:hover': {
            backgroundColor: '#eaf3ff !important',
        },
    },
    actionButton: {
        padding: theme.spacing(.5, 0),
        minWidth: 30,
        borderRadius: 9,
    },
    loadingMediaIcon: {
        animation: '$mapPopupSpin 1s linear infinite',
    },
    fabButton: {
        position: 'fixed',
        bottom: 0,
        right: 0,
        margin: theme.spacing(3),
    },
    mapPopupIntro: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            alignItems: 'stretch',
            flexDirection: 'column',
        },
    },
    mapPopupIntroTitle: {
        color: '#172033',
        fontSize: '1rem',
        fontWeight: 700,
    },
    mapPopupIntroText: {
        color: '#64748b',
        marginTop: 2,
    },
    exportButton: {
        flexShrink: 0,
        borderRadius: 10,
        fontWeight: 600,
        textTransform: 'none',
    },
    mapFiltersCard: {
        padding: theme.spacing(2),
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 14,
    },
    dateTimeInput: {
        width: '100%',
    },
    quickFiltersLabel: {
        color: '#9e9e9e',
        display: 'block',
        fontWeight: 'bold',
        marginBottom: theme.spacing(.75),
        fontSize: '1rem',
    },
    quickFilters: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
    },
    quickFilterButton: {
        borderRadius: 9,
        flex: '1 1 auto',
        minWidth: 68,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        textTransform: 'none',
    },
    mapPopupPanels: {
        marginTop: theme.spacing(1),
    },
    mapPanel: {
        backgroundColor: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: 16,
        boxShadow: '0 12px 32px rgba(15, 23, 42, 0.07)',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 520,
        overflow: 'hidden',
    },
    mapPanelHeader: {
        alignItems: 'flex-start',
        borderBottom: '1px solid #edf1f5',
        display: 'flex',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        padding: theme.spacing(2, 2.5),
    },
    mapPanelTitle: {
        color: '#172033',
        fontSize: '1rem',
        fontWeight: 700,
    },
    mapPanelSubtitle: {
        color: '#64748b',
        marginTop: 2,
    },
    mapTableContainer: {
        flex: 1,
        maxHeight: 'calc(90vh - 385px)',
        minHeight: 350,
        [theme.breakpoints.down('sm')]: {
            maxHeight: '55vh',
            minHeight: 300,
        },
    },
    mapPagination: {
        borderTop: '1px solid #edf1f5',
        flexShrink: 0,
    },
    emptyTableCell: {
        borderBottom: 0,
        height: 300,
    },
    emptyState: {
        alignItems: 'center',
        color: '#64748b',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: 'auto',
        maxWidth: 320,
        padding: theme.spacing(3),
        textAlign: 'center',
    },
    emptyStateIcon: {
        alignItems: 'center',
        backgroundColor: '#eaf3ff',
        borderRadius: '50%',
        color: '#1976d2',
        display: 'flex',
        fontSize: '2rem',
        height: 56,
        justifyContent: 'center',
        marginBottom: theme.spacing(1.5),
        width: 56,
    },
    emptyStateTitle: {
        color: '#334155',
        fontWeight: 700,
        marginBottom: theme.spacing(.5),
    },
    emptyStateText: {
        color: '#64748b',
    },
    mapViewport: {
        alignItems: 'center',
        backgroundColor: '#f1f5f9',
        backgroundImage: 'linear-gradient(rgba(148, 163, 184, .12) 1px, transparent 1px), linear-gradient(90deg, rgba(148, 163, 184, .12) 1px, transparent 1px)',
        backgroundSize: '24px 24px',
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        minHeight: 456,
        overflow: 'auto',
        position: 'relative',
        '& .canvas-pin': {
            display: 'block',
            marginTop: '0 !important',
        },
    },
    mapCanvasStage: {
        flex: '0 0 auto',
        lineHeight: 0,
        margin: 'auto',
        position: 'relative',
    },
    mapPinButton: {
        background: 'transparent',
        border: 0,
        cursor: 'pointer',
        lineHeight: 0,
        padding: 0,
        position: 'absolute',
        zIndex: 2,
        '&:focus-visible': {
            borderRadius: 20,
            outline: '3px solid rgba(25, 118, 210, .35)',
            outlineOffset: 2,
        },
    },
    mapNoDataBanner: {
        backgroundColor: 'rgba(255, 255, 255, .94)',
        border: '1px solid #e2e8f0',
        borderRadius: 10,
        boxShadow: '0 6px 18px rgba(15, 23, 42, .09)',
        color: '#475569',
        fontSize: '.82rem',
        left: '50%',
        padding: theme.spacing(1, 1.5),
        position: 'absolute',
        top: theme.spacing(2),
        transform: 'translateX(-50%)',
        whiteSpace: 'nowrap',
        zIndex: 3,
        [theme.breakpoints.down('xs')]: {
            maxWidth: 'calc(100% - 24px)',
            textAlign: 'center',
            whiteSpace: 'normal',
            width: 'max-content',
        },
    },
    mapLegend: {
        backdropFilter: 'blur(8px)',
        backgroundColor: 'rgba(255, 255, 255, .92)',
        border: '1px solid rgba(226, 232, 240, .95)',
        borderRadius: 12,
        bottom: theme.spacing(1.5),
        boxShadow: '0 8px 24px rgba(15, 23, 42, .12)',
        left: theme.spacing(1.5),
        padding: theme.spacing(1, 1.25),
        position: 'absolute',
        right: theme.spacing(1.5),
        zIndex: 4,
    },
    mapLegendTitle: {
        color: '#475569',
        fontSize: '.7rem',
        fontWeight: 700,
        letterSpacing: '.04em',
        marginBottom: theme.spacing(.5),
        textTransform: 'uppercase',
    },
    mapLegendItems: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(.75, 1.5),
    },
    mapLegendItem: {
        alignItems: 'center',
        color: '#334155',
        display: 'flex',
        fontSize: '.75rem',
        fontWeight: 600,
        gap: 3,
        '& img': {
            height: 18,
            objectFit: 'contain',
            width: 15,
        },
    },
    accessPopupSummary: {
        alignItems: 'center',
        background: 'linear-gradient(135deg, #f0f7ff 0%, #f8fafc 100%)',
        border: '1px solid #dbeafe',
        borderRadius: 14,
        display: 'flex',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            alignItems: 'flex-start',
            flexWrap: 'wrap',
        },
    },
    accessPopupSummaryIcon: {
        alignItems: 'center',
        backgroundColor: '#1976d2',
        borderRadius: 12,
        color: '#fff',
        display: 'flex',
        flexShrink: 0,
        height: 44,
        justifyContent: 'center',
        width: 44,
    },
    accessPopupSummaryText: {
        flex: '1 1 260px',
        minWidth: 0,
    },
    accessPopupSummaryTitle: {
        color: '#172033',
        fontWeight: 700,
    },
    accessPopupSummarySubtitle: {
        color: '#64748b',
        marginTop: 2,
    },
    accessPopupCounters: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(.75),
        justifyContent: 'flex-end',
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'flex-start',
            paddingLeft: 56,
            width: '100%',
        },
    },
    accessPopupCounter: {
        backgroundColor: '#fff',
        border: '1px solid #dbeafe',
        color: '#334155',
        fontWeight: 600,
    },
    accessPopupSections: {
        marginTop: theme.spacing(1),
    },
    accessDeviceSection: {
        border: '1px solid #e2e8f0',
        borderRadius: 14,
        height: '100%',
        overflow: 'hidden',
    },
    accessSectionHeader: {
        alignItems: 'center',
        backgroundColor: '#f8fafc',
        borderBottom: '1px solid #e2e8f0',
        display: 'flex',
        gap: theme.spacing(1),
        justifyContent: 'space-between',
        padding: theme.spacing(1.5, 2),
    },
    accessSectionHeading: {
        alignItems: 'center',
        display: 'flex',
        gap: theme.spacing(1.25),
        minWidth: 0,
    },
    accessSectionIcon: {
        alignItems: 'center',
        backgroundColor: '#e3f2fd',
        borderRadius: 10,
        color: '#1976d2',
        display: 'flex',
        flexShrink: 0,
        height: 38,
        justifyContent: 'center',
        width: 38,
        '& svg': {
            fontSize: 21,
        },
    },
    accessSectionTitle: {
        color: '#1e293b',
        fontWeight: 700,
    },
    accessSectionSubtitle: {
        color: '#64748b',
        fontSize: '.78rem',
        marginTop: 1,
    },
    accessCountChip: {
        backgroundColor: '#e3f2fd',
        color: '#1565c0',
        flexShrink: 0,
        fontWeight: 700,
    },
    accessReaderGrid: {
        padding: theme.spacing(1.5),
    },
    accessDeviceCard: {
        alignItems: 'center',
        backgroundColor: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: 10,
        display: 'flex',
        gap: theme.spacing(1),
        minHeight: 52,
        padding: theme.spacing(1, 1.25),
        transition: 'border-color .2s ease, box-shadow .2s ease, transform .2s ease',
        '&:hover': {
            borderColor: '#90caf9',
            boxShadow: '0 6px 16px rgba(15, 23, 42, .07)',
            transform: 'translateY(-1px)',
        },
    },
    accessDeviceCardIcon: {
        alignItems: 'center',
        backgroundColor: '#f1f5f9',
        borderRadius: 8,
        color: '#475569',
        display: 'flex',
        flexShrink: 0,
        height: 32,
        justifyContent: 'center',
        width: 32,
        '& svg': {
            fontSize: 18,
        },
    },
    accessDeviceName: {
        color: '#334155',
        flex: 1,
        fontSize: '.9rem',
        fontWeight: 600,
        minWidth: 0,
    },
    accessDeviceStatus: {
        alignItems: 'center',
        display: 'flex',
        flexShrink: 0,
    },
    accessAccordionList: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        padding: theme.spacing(1.5),
    },
    accessAccordion: {
        border: '1px solid #e2e8f0',
        borderRadius: '10px !important',
        boxShadow: 'none',
        overflow: 'hidden',
        '&:before': {
            display: 'none',
        },
        '&.Mui-expanded': {
            margin: 0,
        },
    },
    accessAccordionSummary: {
        minHeight: 56,
        padding: theme.spacing(0, 1.25),
        '&.Mui-expanded': {
            backgroundColor: '#f8fafc',
            minHeight: 56,
        },
        '& .MuiAccordionSummary-content': {
            margin: theme.spacing(1, 0),
            minWidth: 0,
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: theme.spacing(1, 0),
        },
    },
    accessAccordionHeading: {
        alignItems: 'center',
        display: 'flex',
        gap: theme.spacing(1),
        minWidth: 0,
        width: '100%',
    },
    accessCameraCount: {
        color: '#64748b',
        flexShrink: 0,
        fontSize: '.72rem',
    },
    accessAccordionDetails: {
        backgroundColor: '#fbfdff',
        borderTop: '1px solid #edf1f5',
        display: 'block',
        padding: theme.spacing(1.5),
    },
    accessCameraCard: {
        alignItems: 'center',
        backgroundColor: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: 9,
        color: '#475569',
        display: 'flex',
        gap: theme.spacing(1),
        minHeight: 42,
        padding: theme.spacing(.75, 1),
        '& svg': {
            color: '#1976d2',
            flexShrink: 0,
            fontSize: 19,
        },
        '& p': {
            fontSize: '.85rem',
            fontWeight: 600,
            minWidth: 0,
        },
    },
    accessNoCameras: {
        color: '#64748b',
        padding: theme.spacing(.5),
        textAlign: 'center',
    },
    accessPopupEmptyState: {
        alignItems: 'center',
        border: '1px dashed #cbd5e1',
        borderRadius: 14,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginTop: theme.spacing(2),
        minHeight: 230,
        padding: theme.spacing(3),
        textAlign: 'center',
    },
    accessPopupEmptyIcon: {
        alignItems: 'center',
        backgroundColor: '#f1f5f9',
        borderRadius: '50%',
        color: '#64748b',
        display: 'flex',
        height: 56,
        justifyContent: 'center',
        marginBottom: theme.spacing(1.5),
        width: 56,
    },
    accessPopupEmptyTitle: {
        color: '#334155',
        fontWeight: 700,
    },
    accessPopupEmptyText: {
        color: '#64748b',
        marginTop: theme.spacing(.5),
        maxWidth: 440,
    },
    accessStatusLegend: {
        alignItems: 'center',
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 12,
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'space-between',
        marginTop: theme.spacing(2),
        padding: theme.spacing(1.25, 1.75),
        [theme.breakpoints.down('sm')]: {
            alignItems: 'flex-start',
            flexDirection: 'column',
        },
    },
    accessStatusLegendTitle: {
        color: '#475569',
        flexShrink: 0,
        fontSize: '.78rem',
        fontWeight: 700,
        letterSpacing: '.03em',
        textTransform: 'uppercase',
    },
    accessStatusLegendItems: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1, 2),
    },
    accessStatusLegendItem: {
        alignItems: 'center',
        color: '#64748b',
        display: 'flex',
        fontSize: '.78rem',
        gap: theme.spacing(.5),
        whiteSpace: 'nowrap',
    },
    '@keyframes mapPopupSpin': {
        from: { transform: 'rotate(0deg)' },
        to: { transform: 'rotate(360deg)' },
    },
    formControl: {
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        '& .MuiTypography-body1': {
            fontSize: '1.2rem',
            userSelect: 'none'
        },
    }
}));
